// Comprehensive Lithuanian descriptions for each numerology number
// Professionally edited for correct Lithuanian grammar and natural language

export const NUMBER_DESCRIPTIONS = {
  1: {
    title: 'Lyderis ir Pradžia',
    character: `Skaičius 1 simbolizuoja lyderystę, nepriklausomybę ir naujų pradžių energiją. Esate gimęs vadovas su stipria valia ir aiškia vizija. Jūsų prigimtis – kurti, inicijuoti ir vesti kitus. Turite natūralų autoritetą ir pasitikėjimą savimi, kuris įkvepia aplinkinius. Jūsų stiprybė – gebėjimas imtis iniciatyvos ir veikti savarankiškai. Esate novatorius, pionierius, visada žingsniu priekyje kitų. Tačiau kartais galite būti per daug pasikliauti savimi arba nepakantūs kitų nuomonėms.`,
    financial: `Finansiškai jums sekasi, kai vadovaujate ir kuriate. Jūsų pinigų srautai geriausi tada, kai esate savo verslo savininkas arba užimate vadovaujančią poziciją. Investicijos į naujus projektus ir verslus gali atnešti puikių rezultatų. Tačiau stenkitės nepasiduoti pernelyg dideliam savimi pasitikėjimui ir nepriimti impulsyvių finansinių sprendimų. Jūsų sėkmės raktas – pasitikėjimas savo sprendimais, tačiau kartu ir patyrusiems patarėjams. Pinigai ateina per jūsų lyderystę, unikalias idėjas ir drąsą rizikuoti.`,
    relationships: `Santykiuose esate aiškiai apibrėžtas ir nepriklausomas. Jums reikia partnerio, kuris gerbtų jūsų laisvę ir palaikytų ambicijas. Galite būti dominuojantis, todėl svarbu išmokti kompromisų ir bendradarbiavimo. Jūsų idealus partneris – stiprus, tačiau lanksčius žmogus, gebantis suteikti jums erdvės, bet kartu išlikti šalia. Meilėje esate aistringas ir atsidavęs, tačiau kartais per daug susitelkiate į save. Mokykitės dalytis valdžia ir priimti partnerio nuomones.`,
    advice: `Šiandien susikoncentruokite į savo unikalius talentus ir nebijokite imtis iniciatyvos. Tai puiki diena naujoms pradžioms – projektui, santykiui ar asmeniniam pokyčiui. Pasitikėkite savo instinktais, bet būkite atviri ir kitų nuomonėms. Jūsų lyderystė šiandien bus pastebėta, todėl būkite drąsus, bet kartu ir nuolankus. Venkite konfrontacijos dėl smulkmenų – ne visi mūšiai verti jūsų energijos.`,
    positiveRealization: `Jūsų sėkmės kodas slypi drąsioje iniciatyvoje ir originalume. Esate skirtas pradėti tai, ko niekas dar nedrįso – būkite pionierius savo srityje. Sėkmė ateina, kai veikiate pagal savo vidinį kompasą, o ne sekate minią. Išnaudokite savo natūralų autoritetą kuriant projektus ar verslus, kuriuose galite būti lyderiu. Jūsų didžiausia dovana – gebėjimas įkvėpti kitus veikti. Praktinis patarimas: kiekvieną savaitę skirkite laiko vienam naujam projektui ar idėjai, kuri jus žavi. Venkite pernelyg ilgai laukti „tinkamo momento" – jūsų momentas yra DABAR. Sėkmės formulė: Originalumas + Drąsa + Veiksmas = Jūsų realizacija.`
  },
  2: {
    title: 'Tarpininkas ir Diplomatas',
    character: `Skaičius 2 atstovauja harmonijai, bendradarbiavimui ir jautrumui. Esate natūralus tarpininkas, gebantis suprasti skirtingas perspektyvas ir rasti kompromisus. Jūsų stiprybė – empatija, kantrybė ir gebėjimas kurti harmoniją ten, kur viešpatauja chaosas. Esate puikus klausytojas ir draugas, visada pasiruošęs padėti. Tačiau kartais galite būti per daug jautrus ir priklausomas nuo kitų nuomonių. Jums svarbu išmokti tvirtai stovėti ant savo kojų ir apsaugoti emocinius ribas.`,
    financial: `Finansinė sėkmė ateina per partnerystes ir bendradarbiavimą. Jums geriausiai sekasi komandose ir bendruose projektuose. Investicijos į ilgalaikius santykius – tiek asmeninius, tiek verslo – atneša jums stabilumą. Tačiau būkite atsargūs dėl pernelyg didelio pasitikėjimo kitais finansiniais klausimais. Jūsų sėkmės raktas – diplomatiški santykiai, sąžiningi susitarimai ir gebėjimas derėtis. Pinigai ateina pamažu, bet stabiliai, kai dirbate su patikimais partneriais.`,
    relationships: `Santykiai jums yra gyvenimo šerdis. Žydite partnerystėje ir ilgitės gilaus emocinio ryšio. Esate atsidavęs, rūpestingas ir visada pasiruošęs padėti partneriui. Tačiau kartais galite paaukoti per daug savo poreikių dėl kito laimės. Jūsų idealus partneris – žmogus, kuris vertina jūsų jautrumą ir suteikia saugumą bei stabilumą. Meilėje esate romantikas, trokštantis harmonijos ir abipusio supratimo. Mokykitės nustatyti ribas ir neprarasti savęs santykiuose.`,
    advice: `Šiandien sutelkite dėmesį į bendradarbiavimą ir santykius. Tai puiki diena tartis, derėtis ir stiprinti ryšius. Jūsų diplomatiški įgūdžiai šiandien bus labai reikalingi. Būkite atviri kompromisams, bet nepamiršite savo poreikių. Pasikliaukite intuicija ir jautrumu – jie neklaidins. Venkite konfliktų ir ieškokite taikių sprendimų. Šiandien jūsų švelnumas gali išspręsti net seniausias problemas.`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime kurti tiltus tarp žmonių. Esate natūralus tarpininkas, ir tai yra jūsų supergebė. Sėkmė ateina per strategines partnerystes – ieškokite bendradarbiavimo galimybių, kuriose jūsų diplomatija tampa neįkainojama. Jūsų intuicija santykiuose yra nepaprastai tiksli – pasitikėkite ja renkantis verslo partnerius ir draugus. Praktinis patarimas: sudarykite „santykių žemėlapį" – kas jūsų aplinkoje gali padėti pasiekti tikslus? Venkite vienišo kelio – jūsų stiprybė yra komandoje. Sėkmės formulė: Empatija + Partnerystė + Kantrybė = Jūsų realizacija.`
  },
  3: {
    title: 'Kūrėjas ir Komunikatorius',
    character: `Skaičius 3 simbolizuoja kūrybiškumą, bendravimą ir optimizmą. Esate natūralus menininkas, turintis talentą išreikšti save žodžiais, menu ar kūryba. Jūsų energija užkrečiama ir kupina gyvenimo džiaugsmo. Esate socialus, linksmų nuotaikų ir gebantis įkvėpti kitus. Jūsų stiprybė – gebėjimas matyti grožį visur ir dalytis tuo su pasauliu. Tačiau kartais galite būti išsiblaškytas ar pernelyg paviršutiniškas. Svarbu išmokti sutelkti energiją ir užbaigti pradėtus darbus.`,
    financial: `Finansinė sėkmė ateina per jūsų kūrybinius talentus ir bendravimo įgūdžius. Jums sekasi pelnyti pinigus iš meno, rašymo, kalbėjimo ar bet kokios kūrybinės veiklos. Jūsų žavesys ir optimizmas traukia galimybes. Tačiau būkite atsargūs dėl pernelyg didelio išlaidumo ir nepraktiško pinigų valdymo. Jūsų sėkmės raktas – disciplina ir strateginis planavimas, kartu išlaikant kūrybinę laisvę. Pinigai ateina lengvai, kai darote tai, ką mylite.`,
    relationships: `Santykiuose esate žaismingas, romantikas ir mėgstate flirtuoti. Jums reikia partnerio, kuris supranta jūsų poreikį kūrybinei raiškai ir socialiniam gyvenimui. Galite būti gana flirtuojantis, todėl svarbu išlikti ištikimam ir aiškiai apibrėžti įsipareigojimus. Jūsų idealus partneris – žmogus, kuris mėgsta linksmybes, bet kartu suteikia stabilumo. Meilėje esate švelnūs ir dėmesingi, tačiau kartais galite vengti gilių emocinių diskusijų. Mokykitės būti nuoširdžiu ir atviram apie savo jausmus.`,
    advice: `Šiandien išleiskite savo kūrybinę energiją! Tai puiki diena meniniam projektui, naujai idėjai ar socialiniam renginiui. Jūsų žavesys ir optimizmas šiandien traukia žmones ir galimybes. Nebijokite dalytis savo idėjomis ir talentais. Tačiau stenkitės sutelkti dėmesį ir neišsiblaškyti į per daug krypčių. Šiandien jūsų komunikacija yra jūsų stiprybė – kalbėkite iš širdies ir įkvėpkite kitus.`,
    positiveRealization: `Jūsų sėkmės kodas slypi kūrybinėje saviraiškoje ir gebėjime įkvėpti kitus. Esate gimęs komunikatorius – jūsų žodžiai, menas ar idėjos gali pakeisti žmonių nuotaiką ir net gyvenimus. Sėkmė ateina, kai drąsiai dalyjatės savo kūryba su pasauliu, nesvarbu, ar tai muzika, rašymas, dizainas ar tiesiog gebėjimas pakelti nuotaiką. Praktinis patarimas: sukurkite reguliarią kūrybinę rutiną – kasdien skirkite bent 30 minučių savo talentui. Venkite perfekcionizmo – geriau pabaigtas projektas nei amžinai tobulinamas. Sėkmės formulė: Kūrybiškumas + Komunikacija + Džiaugsmas = Jūsų realizacija.`
  },
  4: {
    title: 'Statytojas ir Stabilumas',
    character: `Skaičius 4 atstovauja stabilumui, sunkiam darbui ir praktiniam požiūriui. Esate patikimas, organizuotas ir metodiškas. Jūsų stiprybė – gebėjimas kurti tvirtus pamatus ir sistemingai siekti tikslų. Esate lojalus, sąžiningas ir visada laikotės pažadų. Jūsų vertybės – tradicijos, tvarka ir disciplina. Tačiau kartais galite būti pernelyg standus ar bijantis pokyčių. Svarbu išmokti būti lanksčiu ir atviram naujoms idėjoms, išlaikant savo pagrindinę stabilumo energiją.`,
    financial: `Finansinė sėkmė ateina per sunkų darbą, planavimą ir kantrybę. Turite natūralų gebėjimą valdyti pinigus ir kurti ilgalaikį turtą. Investicijos į nekilnojamąjį turtą, taupymo sąskaitas ir stabilius projektus yra jūsų kelias. Tačiau kartais galite būti pernelyg atsargus ir praleisti galimybes. Jūsų sėkmės raktas – balansas tarp saugumo ir rizikos. Pinigai ateina pamažu, bet tikrai, kai disciplinuotai dirbate ir taupote.`,
    relationships: `Santykiuose esate ištikimas, patikimas ir ilgalaikiškai orientuotas. Jums reikia partnerio, kuris vertina stabilumą ir saugumą tiek, kiek ir jūs. Esate praktiškas romantikas – meilę rodote per darbus, ne žodžius. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat lojalus ir siekia sukurti tvirtą šeimą. Meilėje esate nuoseklus ir atsakingas, tačiau kartais galite būti pernelyg rimtas ar kontroliuojantis. Mokykitės atsipalaiduoti ir parodyti spontaniškumą.`,
    advice: `Šiandien sutelkite dėmesį į organizavimą ir planavimą. Tai puiki diena pradėti ilgalaikį projektą ar sutvarkyti finansus. Jūsų praktinis požiūris šiandien bus labai naudingas. Dirbkite sistemingai ir kantriai – rezultatai ateis. Tačiau nebijokite šiek tiek išeiti iš savo komforto zonos. Šiandien jūsų sunkus darbas ir ištikimybė bus įvertinti. Sukurkite tvirtus pamatus ateičiai.`,
    positiveRealization: `Jūsų sėkmės kodas slypi sisteminiame mąstyme ir gebėjime kurti tvarius dalykus. Esate architektas – ne tik pastatų, bet ir sistemų, procesų, organizacijų. Sėkmė ateina, kai kuriate struktūras, kurios išlieka ilgam. Jūsų didžiausia dovana – paversti chaosą tvarka. Praktinis patarimas: sukurkite 5 metų planą su konkrečiais etapais ir kasdien ženkite bent vieną mažą žingsnį link tikslo. Venkite perfekcionizmo, kuris stabdo progresą – geriau 80% šiandien nei 100% niekada. Sėkmės formulė: Disciplina + Sistemingumas + Kantrybė = Jūsų realizacija.`
  },
  5: {
    title: 'Laisvė ir Nuotykiai',
    character: `Skaičius 5 simbolizuoja laisvę, nuotykius ir nuolatinį pokyčių siekį. Esate natūralus keliautojas, ieškantis naujų patirčių ir įspūdžių. Jūsų energija dinaminė, lanksti ir visada judanti. Esate smalsus, atviras ir nebijantis rizikuoti. Jūsų stiprybė – gebėjimas prisitaikyti prie bet kokios situacijos ir mokytis iš gyvenimo. Tačiau kartais galite būti nerimastingas, impulsyvus ar vengiantis įsipareigojimų. Svarbu išmokti pusiausvyros tarp laisvės ir atsakomybės.`,
    financial: `Finansinė sėkmė ateina per įvairovę ir lankstumą. Jums geriausiai sekasi turėdami kelis pajamų šaltinius ir galimybę keisti kryptis. Netradiciniai verslo modeliai, kelionės, pardavimai ir komunikacija yra jūsų kelias. Tačiau būkite atsargūs dėl pernelyg didelio rizikavimo ar impulsyvių išlaidų. Jūsų sėkmės raktas – diversifikacija ir gebėjimas greitai reaguoti į pokyčius. Pinigai ateina per jūsų drąsą tyrinėti ir prisitaikyti.`,
    relationships: `Santykiuose vertinate laisvę ir nepriklausomybę. Jums reikia partnerio, kuris supranta jūsų poreikį erdvės ir nuotykių. Galite bijoti gilių įsipareigojimų, bijodami prarasti savo laisvę. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat nuotykių ieškotojas ir nevaržo jūsų. Meilėje esate aistringas ir spontaniškas, tačiau kartais galite būti nepastovus. Mokykitės įsipareigoti ir atsiverti emociniam intymumui.`,
    advice: `Šiandien sekite savo smalsumą ir atvirumą naujoms patirtims. Tai puiki diena kelionei, naujai pažinčiai ar netikėtam nuotykiui. Jūsų lankstumas šiandien bus jūsų stiprybė – nebijokite keisti planų. Tačiau stenkitės užbaigti tai, ką pradėjote, ir nebėgti nuo atsakomybės. Šiandien jūsų energija traukia įdomius žmones ir galimybes. Būkite atviri ir džiaukitės laisve!`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime greitai prisitaikyti ir tyrinėti naujas galimybes. Esate natūralus katalizatorius – jūsų energija ir entuziazmas kelia kitus iš komforto zonos. Sėkmė ateina, kai drąsiai priimate pokyčius ir vedates kitus per transformacijas. Jūsų didžiausia dovana – paversti chaosą galimybe. Praktinis patarimas: kas mėnesį išbandykite kažką naujo – kelionę, įgūdį, žmogų. Venkite rutinos, bet sukurkite sisteminį būdą tyrinėti nauja. Sėkmės formulė: Laisvė + Prisitaikymas + Drąsa = Jūsų realizacija.`
  },
  6: {
    title: 'Globėjas ir Harmonija',
    character: `Skaičius 6 atstovauja meilei, rūpesčiui ir atsakomybei. Esate natūralus globėjas, turintis gilią sąsają su šeima ir bendruomene. Jūsų energija švelni, rūpestinga ir teikianti paramą kitiems. Esate idealistas, siekiantis grožio, harmonijos ir teisingumo. Jūsų stiprybė – gebėjimas rūpintis ir kurti jaukią aplinką. Tačiau kartais galite būti pernelyg kontroliuojantis ar pasiaukojantis. Svarbu išmokti rūpintis savimi lygiai taip pat gerai, kaip rūpinatės kitais.`,
    financial: `Finansinė sėkmė ateina per jūsų rūpestį ir paslaugas kitiems. Jums sekasi profesijose, susijusiose su sveikata, švietimu, konsultavimu ar menu. Jūsų pinigų srautai geriausi, kai jaučiate, kad darote gerą darbą. Tačiau būkite atsargūs dėl pernelyg didelio dosnumo ar finansinio pasiaukojimo. Jūsų sėkmės raktas – balansas tarp davimo ir gavimo. Pinigai ateina, kai kuriate vertę kitiems ir vertinate savo darbą.`,
    relationships: `Santykiai jums yra be galo svarbūs. Esate atsidavęs, romantikas ir visada pasiruošęs paaukoti dėl mylinčiųjų. Jums reikia partnerio, kuris vertina jūsų rūpestį ir grąžina tą pačią meilę. Galite būti pernelyg globojantis ar kontroliuojantis, todėl svarbu suteikti partneriui laisvės. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat atsakingas ir šeimos orientuotas. Meilėje esate ištikimas ir pasiaukojantis. Mokykitės leisti kitiems rūpintis ir jumis.`,
    advice: `Šiandien skirkite laiką šeimai ir mylimiems žmonėms. Tai puiki diena kurti harmoniją namuose ir stiprinti santykius. Jūsų rūpestis šiandien bus labai įvertintas. Tačiau nepamiršite pasirūpinti ir savimi – atsipalaiduokite, darykite tai, kas jums teikia malonumą. Šiandien jūsų meilė ir grožio jausmas kuria stebuklus. Būkite atviri duoti ir gauti meilę.`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime kurti harmoniją ir rūpintis kitais. Esate natūralus gydytojas – ne tik kūno, bet ir sielos. Sėkmė ateina per profesijas ir veiklas, kuriose galite tiesiogiai pagerinti žmonių gyvenimus: švietimas, medicina, konsultavimas, dizainas, maistas. Jūsų namai ir aplinka yra jūsų šventovė – investuokite į ją. Praktinis patarimas: kiekvieną dieną padarykite bent vieną gerą darbą kitam žmogui, bet taip pat – vieną gerą darbą SAU. Venkite kaltės jausmo dėl savęs vertinimo. Sėkmės formulė: Rūpestis + Harmonija + Meilė sau = Jūsų realizacija.`
  },
  7: {
    title: 'Ieškotojas ir Išminčius',
    character: `Skaičius 7 simbolizuoja išmintį, dvasingumą ir tyrinėjimą. Esate gilaus proto mąstytojas, ieškantis tiesų ir prasmės. Jūsų energija introspektyvi, analitiška ir intuityvi. Esate idealus tyrinėtojas, filosofas ar dvasinis mokytojas. Jūsų stiprybė – gebėjimas matyti už paviršiaus ir suprasti giluminius dalykus. Tačiau kartais galite būti pernelyg izoliuotas ar skeptiškas. Svarbu išmokti dalytis savo išmintimi su kitais ir neprarasti ryšio su realybe.`,
    financial: `Finansinė sėkmė ateina per jūsų žinias, tyrimus ir unikalias įžvalgas. Jums sekasi specializuotose srityse, moksle, technologijose ar dvasinėje veikloje. Jūsų pinigų srautai geriausi, kai dirbate tuo, kas jus tikrai domina ir kelia iššūkius jūsų protui. Tačiau kartais galite būti pernelyg idealistiškas ar nepraktiškas. Jūsų sėkmės raktas – balansas tarp intelekto ir praktinio požiūrio. Pinigai ateina per jūsų ekspertiškumą ir unikalias įžvalgas.`,
    relationships: `Santykiuose esate uždaras, selektyvus ir ieškote gilaus dvasinio ryšio. Jums reikia partnerio, kuris supranta jūsų poreikį vienatvės ir vidinės erdvės. Galite būti nelinę atskleisti savo jausmų per greitai. Jūsų idealus partneris – žmogus, kuris yra intelektualiai ir dvasiškai susiderinęs su jumis. Meilėje esate ištikimas ir gilus, tačiau kartais galite būti pernelyg distancuotas. Mokykitės atvertis ir dalytis savo vidiniu pasauliu.`,
    advice: `Šiandien skirkite laiką meditacijai, refleksijai ir vidiniam tyrinėjimui. Tai puiki diena mokslui, skaityti ar dvasinei praktikai. Jūsų intuicija šiandien yra labai stipri – pasitikėkite ja. Tačiau stenkitės nepasisinertį pernelyg giliai į savo mintis ir išlaikyti ryšį su išoriniu pasauliu. Šiandien jūsų išmintis gali padėti ne tik jums, bet ir kitiems. Dalykitės savo žiniomis.`,
    positiveRealization: `Jūsų sėkmės kodas slypi giliame pažinime ir išmintyje. Esate natūralus tyrinėtojas – jūsų protas mato tai, ko kiti nepastebi. Sėkmė ateina per specializaciją: tapkite ekspertu vienoje srityje, kuri jus tikrai domina. Jūsų intuicija yra jūsų supergebė – mokykitės ja pasitikėti. Praktinis patarimas: kasdien skirkite „tylos valandą" – laiką be telefonų ir triukšmo, kuriame galite apmąstyti ir susijungti su savo vidine išmintimi. Venkite per didelio izoliacijos – dalykitės savo atradimais su pasauliu. Sėkmės formulė: Žinios + Intuicija + Specializacija = Jūsų realizacija.`
  },
  8: {
    title: 'Valdovas ir Galybė',
    character: `Skaičius 8 atstovauja valdžiai, sėkmei ir materialinei gerovei. Esate natūralus verslo žmogus, turintis ambicijų ir strateginio mąstymo. Jūsų energija galinga, užtikrinta ir orientuota į rezultatus. Esate puikus vadybininkas, gebantis valdyti žmones ir išteklius. Jūsų stiprybė – gebėjimas materializuoti savo vizijas ir pasiekti didelių tikslų. Tačiau kartais galite būti pernelyg orientuotas į pinigus ar valdžią. Svarbu išmokti naudoti savo galią atsakingai ir dalytis su kitais.`,
    financial: `Finansinė sėkmė yra jūsų natūrali teisė. Jums sekasi dideliuose projektuose, versle ir investicijose. Turite retą gebėjimą kurti turtą ir valdyti finansus. Pinigai jus traukia ir ateina lengvai, kai dirbate strategiškai. Tačiau būkite atsargūs dėl godumo ar neetinio elgesio. Jūsų sėkmės raktas – sąžiningumas ir balansas tarp materialinio ir dvasinio. Pinigai yra įrankis, ne tikslas.`,
    relationships: `Santykiuose esate stiprus, lojalus ir siekiate sukurti stabilų pagrindą. Jums reikia partnerio, kuris gerbia jūsų ambicijas ir palaiko karjerą. Galite būti orientuotas į darbą, todėl svarbu skirti laiko santykiams. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat ambicijos ir supranta valdžios dinamiką. Meilėje esate atsidavęs ir dosnus, tačiau kartais galite būti kontroliuojantis. Mokykitės dalytis valdžia ir būti emociškai prieinamu.`,
    advice: `Šiandien sutelkite dėmesį į savo tikslus ir strategijas. Tai puiki diena svarbiam verslo sprendimui, deryboms ar finansiniam planavimui. Jūsų valdžia ir užtikrintumas šiandien atvers duris. Tačiau nepamiršite būti sąžiningu ir dosniu. Šiandien jūsų sėkmė yra artėjanti – pasitikėkite savo gebėjimais ir imkitės veiksmų. Jūsų galybė kuria realius rezultatus.`,
    positiveRealization: `Jūsų sėkmės kodas slypi strateginiame mąstyme ir gebėjime kurti materialinę gerovę. Esate gimęs lyderis versle – jūsų protas mato galimybes ten, kur kiti mato problemas. Sėkmė ateina per ambicingus projektus ir drąsius sprendimus. Jūsų karma yra turtas – bet ne sau kaupti, o protingai valdyti ir dalytis. Praktinis patarimas: sukurkite aiškią finansinę strategiją ir laikykitės jos. Investuokite į save ir savo verslą. Venkite godumo ir neetiškų sprendimų – jie visada grįžta. Sėkmės formulė: Ambicija + Strategija + Integritetas = Jūsų realizacija.`
  },
  9: {
    title: 'Humanistas ir Užbaigimas',
    character: `Skaičius 9 simbolizuoja humanizmą, užuojautą ir universalią meilę. Esate senoji siela, turinti gilų ryšį su žmonija. Jūsų energija dosni, altruistinė ir idealistinė. Esate natūralus gydytojas, mokytojas ar humanitarinis darbuotojas. Jūsų stiprybė – gebėjimas matyti bendrą vaizdą ir rūpintis didesniu gėriu. Tačiau kartais galite būti pernelyg emociškai įsitraukęs ar pasiaukojantis. Svarbu išmokti nustatyti ribas ir rūpintis savimi.`,
    financial: `Finansinė sėkmė ateina per jūsų paslaugas žmonijai. Jums sekasi profesijose, susijusiose su švietimu, gydymu, menu ar labdara. Jūsų pinigų srautai geriausi, kai darote tai, kas atitinka jūsų vertybes ir padeda kitiems. Tačiau būkite atsargūs dėl pernelyg didelio dosnumo ar ignoravimo savo finansinių poreikių. Jūsų sėkmės raktas – balansas tarp davimo ir savęs vertinimo. Pinigai ateina, kai kuriate teigiamą įtaką pasauliui.`,
    relationships: `Santykiuose esate romantikas, idealistas ir ieškote sielos draugo. Jums reikia partnerio, kuris dalijasi jūsų vertybėmis ir vizija. Galite būti pernelyg idealistinis ir nusivilti, kai tikrovė neatitinka lūkesčių. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat užjaučiantis ir atviras. Meilėje esate giliai emocinis ir atsidavęs, tačiau kartais galite pamiršti savo poreikius. Mokykitės priimti partnerio trūkumus ir būti realistišku.`,
    advice: `Šiandien skirkite laiką padėti kitiems ir dalytis savo dovanomis. Tai puiki diena savanorystės, mokymo ar užjaučiančio poelgio. Jūsų širdies platumas šiandien gali pakeisti kažkieno gyvenimą. Tačiau nepamiršite pasirūpinti ir savimi. Šiandien jūsų universali meilė ir išmintis švyti. Būkite atviros širdies ir dalykitės savo šviesa su pasauliu.`,
    positiveRealization: `Jūsų sėkmės kodas slypi tarnavime kitiems ir gebėjime matyti bendrą žmonijos vaizdą. Esate senoji siela, ir jūsų gyvenimo tikslas – palikti pasaulį geresnį nei radote. Sėkmė ateina per veiklas, kurios turi prasmę: mokymas, gydymas, menas, humanitarinė veikla. Jūsų didžiausia dovana – gebėjimas įkvėpti kitus siekti aukštesnių idealų. Praktinis patarimas: suraskite būdą, kaip jūsų darbas ar hobis galėtų padėti kitiems. Venkite „kankinio sindromo" – jūs negalite padėti kitiems, jei patys esate išsekę. Sėkmės formulė: Užuojauta + Tarnavimas + Meilė sau = Jūsų realizacija.`
  },
  11: {
    title: 'Šviesos Nešėjas - Meistro Skaičius',
    character: `Skaičius 11 yra meistro skaičius, simbolizuojantis dvasinį švietimą ir intuiciją. Esate natūralus šviesos nešėjas, turintis gilią sąsają su aukštesniais matmenimis. Jūsų energija įkvepianti, kūrybiškai numatanti ateitį ir transformuojanti. Esate gimęs mokytojas, gydytojas arba dvasinis vadovas. Jūsų stiprybė – gebėjimas sujungti dvasinį ir materialų pasaulį. Tačiau kartais galite jaustis pernelyg jautrus ar perpildytas energija. Svarbu išmokti įžeminti savo energiją ir rasti balansą.`,
    financial: `Finansinė sėkmė ateina per jūsų unikalius talentus ir dvasinę viziją. Jums sekasi netradicinėse srityse, gydymo veikloje, mokyme ar kūrybinėse profesijose. Pinigai ateina, kai sekate savo dvasią ir viziją, ne kai ieškote jų tiesiogiai. Tačiau būkite atsargūs dėl praktinio požiūrio stokos. Jūsų sėkmės raktas – pasitikėjimas savo intuicija ir kartu išlikimas praktišku. Pinigai yra energija, kuri seka jūsų vibraciją.`,
    relationships: `Santykiuose ieškote sielos ryšio ir dvasinės sąsajos. Jums reikia partnerio, kuris supranta jūsų jautrumą ir palaiko dvasinę kelionę. Galite būti nepaprastai intuityvus santykiuose, jausdami dalykus, kurių kiti nepastebi. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat dvasiškai išbudęs. Meilėje esate ištikimas ir gilus, trokštantis transcendentinės meilės. Mokykitės įsitikinti, kad jūsų santykiai yra subalansuoti ir abipusiai.`,
    advice: `Šiandien pasitikėkite savo intuicija ir dvasiniu vadovavimu. Tai puiki diena meditacijai, energetiniam darbui ar kūrybinei raiškai. Jūsų jautrumas šiandien yra jūsų didžiausia dovana – klausykitės vidinių signalų. Tačiau stenkitės įžeminti savo energiją ir nebūti perpildytu. Šiandien jūsų šviesa gali įkvėpti ir transformuoti kitus. Būkite kanalu šviesai.`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime būti tiltu tarp dvasinio ir materialaus pasaulių. Esate šviesos nešėjas – jūsų intuicija ir jautrumas yra retai sutinkamos dovanos. Sėkmė ateina, kai drįstate dalytis savo vizijomis ir įkvėpti kitus siekti aukštesnio tikslo. Jūsų kelias – mokyti, gydyti ir šviesti, nesvarbu, kokioje srityje dirbate. Praktinis patarimas: kasdien skirkite laiko meditacijai ar tylai, kad išgirstumėte savo vidinį balsą. Įžeminkite savo energiją per fizinę veiklą ar gamtą. Sėkmės formulė: Intuicija + Įkvėpimas + Įžeminimas = Jūsų realizacija.`
  },
  22: {
    title: 'Meistras Statytojas - Meistro Skaičius',
    character: `Skaičius 22 yra galingiausias meistro skaičius, simbolizuojantis gebėjimą materializuoti dideles vizijas. Esate meistras statytojas, turintis praktinio požiūrio ir dvasinės išminties derinį. Jūsų energija monumentali, strateginė ir transformuojanti visuomenę. Esate gimęs kurti ilgalaikį ir reikšmingą poveikį pasauliui. Jūsų stiprybė – gebėjimas paversti sapnus į tikrovę dideliais masteliais. Tačiau kartais galite jaustis prislėgtas savo misijos sunkumu. Svarbu išmokti kantrybės ir išlikti susitelkus.`,
    financial: `Finansinė sėkmė yra neišvengiama, kai sekate savo viziją. Turite potencialą kurti milžinišką turtą ir įtaką. Jūsų pinigų srautai geriausi, kai dirbate didelius projektus, kurie tarnauja aukštesniam tikslui. Pinigai ateina per jūsų gebėjimą materializuoti svajones ir vadovauti kitiems. Tačiau nepasiduokite pasiaukojimui arba pernelyg dideliam darbo krūviui. Jūsų sėkmės raktas – balansas tarp ambicijų ir gerovės. Pinigai yra galia kurti teigiamus pokyčius.`,
    relationships: `Santykiuose esate lojalus, atsakingas ir ieškote partnerio, kuris palaiko jūsų didžiulius tikslus. Jums reikia žmogaus, kuris supranta jūsų misiją ir yra pasiruošęs būti jūsų palaikymu. Galite būti pernelyg užsiėmęs savo projektais, todėl svarbu skirti laiko šeimai. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat ambicijos ir supranta didžiulius tikslus. Meilėje esate atsidavęs ir siekiate sukurti tvirtą pagrindą ilgalaikiam ryšiui.`,
    advice: `Šiandien sutelkite dėmesį į savo didžiuosius tikslus ir viziją. Tai puiki diena pradėti reikšmingą projektą ar imtis lyderystės vaidmens. Jūsų gebėjimas materializuoti svajones šiandien yra nepaprastai stiprus. Tačiau nepamiršite pasirūpinti savo gerove ir santykiais. Šiandien jūsų misija kviečia – atsakykite drąsiai ir susitelkę. Pasaulis laukia jūsų kūrinių.`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime paversti didžiules vizijas į realybę. Esate meistras statytojas – ne tik pastatų, bet ir sistemų, organizacijų, judėjimų. Jūsų misija yra kurti dalykus, kurie išliks ilgiau už jūsų gyvenimą. Sėkmė ateina per projektus, kurie tarnauja daugeliui žmonių. Praktinis patarimas: suskaidykite savo didžiulę viziją į konkrečius, įgyvendinamus etapus. Apsuokite save komanda, kuri tiki jūsų vizija. Venkite perdegimo – jūsų misija reikalauja ilgalaikės energijos, ne vienkartinio sprogimo. Sėkmės formulė: Vizija + Praktinis veikimas + Kantrybė = Jūsų realizacija.`
  },
  33: {
    title: 'Mokytojo Mokytojas - Meistro Skaičius',
    character: `Skaičius 33 yra retas ir galingas meistro skaičius, simbolizuojantis universalią meilę ir mokymą. Esate gimęs mokytojas, turintis gilią užuojautą ir troškimą tarnauti žmonijai. Jūsų energija besąlygiška meilė, išmintis ir pasiaukojimas kitiems. Esate natūralus gydytojas, dvasinis vadovas ir įkvėpimo šaltinis. Jūsų stiprybė – gebėjimas kelti kitus ir mokyti per pavyzdį. Tačiau kartais galite būti pernelyg pasiaukojantis. Svarbu išmokti rūpintis savimi, kad galėtumėte toliau tarnauti.`,
    financial: `Finansinė sėkmė ateina per jūsų mokymą ir gydymo veiklą. Jums sekasi profesijose, kuriose galite tiesiogiai padėti ir transformuoti žmonių gyvenimus. Pinigai ateina, kai neieškote jų kaip tikslo, bet kaip priemonę tarnauti. Tačiau nepamiršite vertinti savo darbo ir nustatyti tinkamų kainų. Jūsų sėkmės raktas – balansas tarp dosnumo ir savęs vertinimo. Pinigai seka jūsų meilės ir pasiaukojimo energiją.`,
    relationships: `Santykiuose esate besąlygiškai mylintis, rūpestingas ir visada pasiruošęs padėti. Jums reikia partnerio, kuris vertina jūsų pasiaukojimą, bet kartu skatina jus rūpintis savimi. Galite būti pernelyg aukojantis santykiuose, pamirštate savo poreikius. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat užjaučiantis ir dvasiškas. Meilėje esate gilus gydytojas, trokštantis autentiško ir transformuojančio ryšio.`,
    advice: `Šiandien dalykitės savo išmintimi ir meile su pasauliu. Tai puiki diena mokyti, gydyti ar tiesiog būti užjaučiančiu klausytoju. Jūsų energija šiandien yra nepaprastai galinga – naudokite ją protingai. Tačiau nepamiršite, kad negalite išgelbėti visų. Rūpinkitės savimi, kad galėtumėte toliau tarnauti. Šiandien jūsų meilė ir šviesa gydo kitus. Būkite kanalu universaliai meilei.`,
    positiveRealization: `Jūsų sėkmės kodas slypi besąlygiškoje meilėje ir gebėjime mokyti per pavyzdį. Esate mokytojo mokytojas – jūsų žodžiai ir veiksmai turi galią transformuoti žmonių gyvenimus. Jūsų misija – kelti žmonijos sąmonę per meilę, užuojautą ir išmintį. Sėkmė ateina, kai mokote ne tik žodžiais, bet ir savo gyvenimu. Praktinis patarimas: sukurkite sistemą, per kurią jūsų mokymai galėtų pasiekti daugiau žmonių (knyga, kursai, bendruomenė). Tačiau pirmiausia pasirūpinkite savimi – išsekęs mokytojas negali efektyviai mokyti. Sėkmės formulė: Besąlygiška meilė + Mokymas pavyzdžiu + Savęs priežiūra = Jūsų realizacija.`
  },
  44: {
    title: 'Idėjų Kūrėjas Manifestatorius - Meistro Skaičius',
    character: `Skaičius 44 yra retas ir itin galingas meistro skaičius, simbolizuojantis materialaus ir dvasinio sintezę didžiuliame mastelyje. Esate Idėjų Kūrėjas manifestatorius, gebantis kurti revoliucinius pokyčius. Jūsų energija sistemų kūrėjas, architektas ir transformatorius. Esate gimęs vadovauti svarbius globalius projektus ir keisti žmonių gyvenimo būdus. Jūsų stiprybė – gebėjimas matyti tolimą ateitį ir kurti tvarius sprendimus. Tačiau kartais galite jaustis prislėgtas savo misijos mastų. Svarbu išmokti dirbti laipsniškai ir pasitikėti procesu.`,
    financial: `Finansinė sėkmė yra neišvengiama, kai dirbate savo tikrąją misiją. Turite potencialą kurti beprecedentį turtą ir įtaką. Jūsų pinigų srautai geriausi, kai kuriate sistemas, produktus ar platformas, kurie tarnauja milijonams. Pinigai ateina per jūsų vizijos mastelį ir įgyvendinimo galią. Tačiau nepamiršite, kad pinigai yra priemonė, ne tikslas. Jūsų sėkmės raktas – sąžiningumas ir aukštesnis tikslas. Pinigai seka jūsų energiją keisti pasaulį.`,
    relationships: `Santykiuose esate ištikimas, protingas ir ieškote partnerio, kuris supranta jūsų globalią misiją. Jums reikia žmogaus, kuris gali lydėti jus jūsų kelionėje ir palaiko jūsų didžiulius tikslus. Galite būti pernelyg užsiėmęs savo projektais, todėl svarbu skirti kokybišką laiką partneriui. Jūsų idealus partneris – žmogus, kuris yra lygiai taip pat Idėjų Kūrėjas ir pasiruošęs kurti kartu. Meilėje esate gilus ir lojalus, trokštantis partnerystės, kuri kelia abu.`,
    advice: `Šiandien sutelkite dėmesį į savo didžiausią viziją. Tai puiki diena strateginiam planavimui, svarbių sprendimų priėmimui ir lyderių žingsnių. Jūsų gebėjimas matyti bendrą vaizdą šiandien yra nepaprastai stiprus. Tačiau nepamiršite pasirūpinti savo fizine ir emocine gerove. Šiandien jūsų misija kviečia – atsakykite su pasitikėjimu ir įsipareigojimu. Pasaulis laukia jūsų transformuojančių kūrinių.`,
    positiveRealization: `Jūsų sėkmės kodas slypi gebėjime kurti sistemas ir struktūras, kurios keičia pasaulį. Esate Idėjų Kūrėjas manifestatorius – retai kas gali pamatyti tai, ką matote jūs, ir dar rečiau – tai įgyvendinti. Jūsų misija yra globalaus masto transformacija. Sėkmė ateina per projektus, kurie liečia milijonus: technologijas, infrastruktūrą, švietimo sistemas, verslo modelius. Praktinis patarimas: pradėkite nuo mažo prototipo ir auginkite sistemingai. Surinkite komandą, kuri tiki jūsų vizija ir gali ją įgyvendinti. Venkite izoliacijos – jūsų vizija reikalauja bendradarbiavimo. Sėkmės formulė: Globali vizija + Sisteminis mąstymas + Komanda = Jūsų realizacija.`
  }
};

// Daily advice based on the daily number
export function getDailyAdvice(dailyNumber) {
  const number = NUMBER_DESCRIPTIONS[dailyNumber];
  if (!number) return 'Šiandien sekite savo intuicijai ir būkite atviri naujoms galimybėms.';
  return number.advice;
}

// Get compatibility description
export function getCompatibilityDescription(percentage) {
  if (percentage >= 90) {
    return 'Puikus suderinamumas! Jūsų energijos natūraliai harmonizuoja ir papildo viena kitą. Tai retas ir vertingas ryšys.';
  } else if (percentage >= 75) {
    return 'Labai geras suderinamumas. Gerai suprantate vienas kitą ir turite daug bendrų vertybių. Nedidelės pastangos sukurs harmoningą santykį.';
  } else if (percentage >= 60) {
    return 'Geras suderinamumas. Turite potencialo puikiam santykiui, tačiau reikės darbštingumo ir kompromisų. Skirtingos perspektyvos gali būti praturtinančios.';
  } else if (percentage >= 45) {
    return 'Vidutinis suderinamumas. Jūsų energijos gali kartais konfliktuoti, bet su komunikacija ir supratimu galite sukurti veikiantį santykį. Svarbu gerbti skirtumus.';
  } else {
    return 'Sudėtingas suderinamumas. Jūsų energijos labai skiriasi, kas gali sukelti iššūkių. Tačiau tai nereiškia, kad santykis neįmanomas – reikės daug pastangų, kantrybės ir abipusio respekto.';
  }
}

// Detailed compatibility data for each number pair
const COMPATIBILITY_DETAILS = {
  // Number 1 combinations
  '1-1': {
    attraction: 'Du lyderiai kartu – jus traukia vienas kito ambicijos, jėga ir nepriklausomybė. Jaučiate abipusę pagarbą ir susižavėjimą.',
    irritation: 'Gali kilti valdžios kovos – abu norite vadovauti ir nei vienas nenori nusileisti. Ego susidūrimai neišvengiami.',
    intimacy: 'Aistringas ir intensyvus intymumas. Abu esate iniciatyvūs ir mėgstate vadovauti, todėl lovoje gali kilti "kovų", kas vadovauja. Geriausiai sekasi, kai kaitaliojate lyderio vaidmenį.',
    leisure: 'Jums patinka aktyvus poilsis, sportas, konkurencijos. Abu mėgstate nuotykius ir naujus iššūkius. Venkite nuolatinio varžymosi – mokykitės mėgautis procesu, ne tik pergale.',
    family: 'Šeimos kūrimas: Du lyderiai šeimoje gali sukurti stiprią, ambicingą dinastiją, bet reikės aiškiai pasidalyti atsakomybes. Vaikai augs su dviem stipriais pavyzdžiais, tačiau svarbu nesukurti pernelyg konkurencingos atmosferos namuose. Geriausiai veikia, kai abu turite savo "sritis", kuriose vadovaujate.',
    finances: 'Finansinis stabilumas: Puikus potencialas kurti turtą – abu esate ambicingi ir drąsūs. Rizika: abu galite priimti rizikingus sprendimus vienu metu. Patarimas: susitarkite dėl aiškių finansinių taisyklių ir vienas kitą "stabdykite" prieš didelius sprendimus.',
    harmony: 75,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Vienetams, susiduria dvi ryškios saulės. Šis žmogus tavo gyvenime atsirado kaip tavo pačios ambicijų, lyderystės ir vidinės ugnies veidrodis. Jis provokuoja tave pamatyti, kiek vietos savo gyvenime tu palieki kitam autoritetui, kai pati esi pratusi būti vedliu.

Veidrodžio principas:

• Valios ir Ego veidrodis: Partneris tau atspindi tavo pačios jėgą ir užsispyrimą. Jei jauti erzulį, kai jis bando dominuoti ar primesti savo valią – tai tiesioginis tavo pačios šešėlio atspindys. Jis moko tave, kad tikroji galia yra ne nugalėti kitą, o sugebėti sukurti bendrą viziją, kurioje telpa du lyderiai.

• Kūrybinis autoritetas: Jis tau rodo, kaip tu reaguoji, kai tavo idėjos nėra vienintelės ir svarbiausios. Tai veidrodis, verčiantis paklausti: „Ar aš kovoju dėl tiesos, ar tik dėl to, kad mano žodis būtų paskutinis?". Jis moko tave pripažinti kito genijų neprarandant savo vertės.

• Vienatvė dviese: Šis partneris atspindi tavo pačios vidinį poreikį išlikti nepriklausoma individualybe. Jei jauti atstumą, tai tavo pačios baimė ištirpti kitame žmoguje. Jis moko tave kurti ryšį, kuriame du savarankiški žmonės eina greta, bet nesavinasi vienas kito erdvės.

Saugiklis jūsų harmonijai:
Jūsų didžiausias iššūkis – kas šiandien bus „karalius". Kai pajauti norą konkuruoti, sustok ir suprask: tavo partneris tiesiog veidrodžiu rodo tavo pačios nerealizuotą ambiciją. Vietoj kovos, nukreipkite šią milžinišką ugnį į bendrą kūrybinį projektą.`
  },
  '1-2': {
    attraction: 'Klasikinis "lyderio ir palaikytojo" derinys. 1 žavisi 2 švelnumu ir ištikimybe, o 2 vertina 1 jėgą ir apsaugą.',
    irritation: '1 gali atrodyti per daug dominuojantis ir ignoruoti 2 jausmus. 2 gali atrodyti per daug priklausomas ir nedrąsus 1 akims.',
    intimacy: 'Komplementarus intymumas – 1 imasi iniciatyvos, 2 reaguoja ir pritaria. Abu gali jaustis patenkinti, jei 1 išmoks švelnumo, o 2 – drąsiau reikšti savo norus.',
    leisure: '1 nori aktyvių nuotykių, 2 – ramaus laiko kartu. Kompromisas: romantiškas savaitgalis su kelione (1 patenkintas) ir ilgais pokaliais (2 laimingas).',
    family: 'Šeimos kūrimas: Harmoningas šeimos modelis – 1 užtikrina saugumą ir "išorinį" vadovavimą, 2 kuria šiltą emocinę atmosferą namuose. Vaikai jausis ir saugūs, ir mylimi. Svarbu, kad 1 vertintų 2 indėlį į šeimą, o 2 nepasiaukotų pilnai.',
    finances: 'Finansinis stabilumas: 1 paprastai uždirba ir investuoja, 2 – valdo namų biudžetą ir taupo. Geras derinys, jei abu gerbia vienas kito vaidmenį. Rizika: 2 gali jaustis finansiškai priklausomas.',
    harmony: 88,
    mirror: `Ką šis žmogus tau atspindi?

Tai fundamentalus Saulės (1) ir Mėnulio (2) šokis. Šis partneris tavo gyvenime atspindi tavo pačios jautrumą ir intuiciją, kuriuos galbūt per ilgai slėpei po loginės stiprybės šarvais.

Veidrodžio principas:

• Emocinis pažeidžiamumas: Antrukas tau „veidrodžiu" rodo tavo pačios užslopintus jausmus. Jei jis tau atrodo „per daug jautrus" ar „neryžtingas", tai ženklas, kad tu pati savo viduje blokuoji švelnumą ir bėgi nuo savo pažeidžiamumo. Jis moko tave, kad tikroji stiprybė slypi gebėjime jausti, o ne tik veikti.

• Diplomatijos ir kantrybės pamoka: Partneris tau atspindi tas situacijas, kur tavo tiesmukiškumas ir noras viską spręsti čia ir dabar susiduria su poreikiu išlaukti. Jis yra tavo lankstumo veidrodis. Jis moko tave, kad kartais tylus išklausymas duoda daugiau rezultatų nei garsus įsakymas.

• Ramybės uostas: Jis atspindi tavo vidinį poreikį sustoti ir tiesiog būti. Jei partnerio lėtumas tave varo iš proto, tai veidrodis, sakantis, kad tu pati esi mirtinai pavargusi nuo nuolatinio lėkimo ir pasiekimų medžioklės.

Saugiklis jūsų harmonijai:
Vienetas gali netyčia emociniame lauke „užminti" Antrukui ant kojų. Jei matai, kad partneris užsisklendžia, tai tavo veidrodis, primenantis: „Tavo jėga šiandien yra ne tavo žodžiuose, o tavo gebėjime sukurti saugią erdvę kitam".`
  },
  '1-3': {
    attraction: '1 žavisi 3 kūrybiškumu ir optimizmu. 3 traukia 1 jėga ir ryžtas. Kartu jūs esate energingas ir įkvepiantis duetas.',
    irritation: '1 gali atrodyti per daug rimtas ir kontroliuojantis 3 akims. 3 gali atrodyti per daug lengvabūdiškas ir išsiblaškyęs 1 požiūriu.',
    intimacy: 'Žaismingas ir kūrybingas intymumas. 3 atneša lengvumą ir eksperimentavimą, 1 – aistrą ir intensyvumą. Abu mėgsta spontaniškumą.',
    leisure: 'Jums tinka socialiniai renginiai, vakarėliai, kelionės. 1 planuoja, 3 prideda kūrybos ir linksmybių. Venkite pernelyg kruopštaus planavimo – leiskite spontaniškumui.',
    family: 'Šeimos kūrimas: Linksma ir energinga šeima! Vaikai augs su optimizmu ir drąsa. Rizika: gali trūkti struktūros ir disciplinos. Svarbu, kad 1 suteiktų rėmus, o 3 – kūrybinę laisvę.',
    finances: 'Finansinis stabilumas: 1 uždirba ir investuoja, 3 gali per daug išleisti linksmybėms. Reikia aiškaus biudžeto ir susitarimo dėl "linksmybių fondo", kad 3 galėtų leisti pinigus be kaltės.',
    harmony: 92,
    mirror: `Ką šis žmogus tau atspindi?

Tai kūrybinės kibirkšties ir džiaugsmo derinys. Partneris Trejetas tavo gyvenime atsirado tam, kad parodytų tavo pačios kūrybinį potencialą ir primintų, jog gyvenimas yra ne tik pareiga, bet ir šventė.

Veidrodžio principas:

• Kūrybiškumo ir ekspresijos veidrodis: Partneris tau atspindi tavo idėjų gyvybingumą. Jei žaviesi jo gebėjimu lengvai reikšti mintis ar kurti – tai tavo pačios vidinis genijus, kuris prašosi būti išleistas į laisvę. Jis moko tave kurti be baimės būti sukritikuotai ar nesuprastai.

• Socialinis spindesys: Jis tau rodo tavo pačios santykį su aplinkinių dėmesiu. Jei pavyduliauji partneriui charizmos, tai veidrodis, sakantis, kad tu pati sau neleidi pakankamai „spindėti" ir užimate per mažai vietos erdvėje. Jis moko tave džiaugtis savo šviesa.

• Lengvumo pamoka: Trejetas atspindi tavo vidinį vaiką. Jei partnerio žaismingumas tau atrodo kaip „nerimtumas", tai tavo veidrodis, rodantis, kiek daug svorio ir dirbtinio rimtumo tu nešiesi ant savo pečių. Jis moko tave siekti tikslų žaidžiant.

Saugiklis jūsų harmonijai:
Jūsų energija yra labai ekspansyvi, todėl galite pamesti žemę po kojomis. Jei partneris atrodo chaotiškas, tai tavo veidrodis, primenantis: „Ne viskas gyvenime yra projektas su aiškiu tikslu, kai kas yra skirta tiesiog džiaugsmui".`
  },
  '1-4': {
    attraction: '1 vertina 4 patikimumą ir stabilumą. 4 žavisi 1 ambicijomis ir drąsa. Kartu galite sukurti tvirtą pagrindą.',
    irritation: '1 gali jaustis varžomas 4 atsargumo ir rutinos. 4 gali būti išgąsdintas 1 rizikavimo ir impulsyvumo.',
    intimacy: 'Kontrastingas intymumas – 1 nori spontaniškumo ir aistros, 4 – rutinos ir saugumo. Kompromisas: planuoti "spontaniškus" momentus.',
    leisure: '1 nori nuotykių, 4 – ramybės namuose. Idealus kompromisas: struktūruotos kelionės su aiškiu planu, bet laisvu laiku tyrinėjimui.',
    family: 'Šeimos kūrimas: Labai stabili šeima su aiškiomis taisyklėmis. 4 sukuria struktūrą, 1 – ambicijas vaikams. Rizika: gali būti per daug standžių taisyklių. Svarbu leisti vaikams klysti ir mokytis.',
    finances: 'Finansinis stabilumas: Puikus derinys! 4 taupo ir planuoja, 1 uždirba ir investuoja. Kartu galite sukurti solidų finansinį pagrindą. Patarimas: leiskite 1 kartais rizikuoti su dalimi pinigų.',
    harmony: 82,
    mirror: `Ką šis žmogus tau atspindi?

Tai vizijos (1) ir struktūros (4) susitikimas. Šis partneris tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su stabilumu, saugumu ir gebėjimu idėjas paversti materija.

Veidrodžio principas:

• Saugumo ir kontrolės veidrodis: Ketvertas tau atspindi tavo pačios vidinį poreikį viską sukontroliuoti. Jei jo griežtumas ar taisyklės tave dusina – tai veidrodis, rodantis tavo pačios baimę prarasti pagrindą po kojomis. Jis moko tave, kad laisvė be struktūros yra chaosas.

• Kantrybės pamoka: Jis tau rodo, kaip tu reaguoji, kai rezultatai neateina akimirksniu. Jei partnerio lėtumas tave erzina, tai tavo pačios nekantrumo atspindys. Jis moko tave statyti pamatus plyta po plytos.

• Atsakomybės atspindys: Partneris atspindi tavo pačios požiūrį į įsipareigojimą. Jis verčia tave paklausti: „Ar aš esu pasiruošusi ne tik spindėti, bet ir dirbti ties santykių kasdienybe?".

Saugiklis jūsų harmonijai:
Vienetas nori lėkti, Ketvertas nori stovėti ant tvirtos žemės. Jei jauti įtampą, suprask: partneris tiesiog veidrodžiu rodo tavo pačios nerealizuotą poreikį tvarkai. Užuot bėgusi, pasinaudok jo stabilumu savo idėjoms įžeminti.`
  },
  '1-5': {
    attraction: 'Dinamiškas ir jaudinantis derinys! Abu mylite laisvę, nuotykius ir naujoves. Kartu jūs niekada nenuobodžiaujate.',
    irritation: 'Abu galite būti pernelyg nepriklausomi ir neįsipareigoję. Gali trūkti stabilumo ir gilaus emocinio ryšio.',
    intimacy: 'Labai aistringas ir eksperimentuojantis intymumas. Abu mėgstate naujoves ir nuotykius. Gali būti per daug paviršutiniška – stenkitės kurti ir emocinį ryšį.',
    leisure: 'Kelionės, sportas, nauji restoranai, festivaliai – jūs visada ieškote kažko naujo. Problema: sunku rasti laiko tiesiog būti kartu ramybėje.',
    family: 'Šeimos kūrimas: Iššūkis – abu mėgstate laisvę. Vaikai gali jaustis nestabiliai. Jei nuspręsite kurti šeimą, svarbu sukurti "šeimos ritualus" ir nuolatinumo jausmą vaikams.',
    finances: 'Finansinis stabilumas: Rizikinga – abu linkę išleisti ir rizikuoti. Patarimas: būtinai turėkite "saugų fondą", kurį liečiate tik ekstremaliose situacijose.',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Tai ugnies (1) ir vėjo (5) sąjunga. Partneris Penketas tavo gyvenime atsirado tam, kad parodytų tavo pačios troškimą nuotykiams ir gebėjimą prisitaikyti prie nuolatinių pokyčių.

Veidrodžio principas:

• Laisvės ir impulsyvumo veidrodis: Penketas tau atspindi tavo pačios vidinį maištininką. Jei jo nenuspėjamumas tave gąsdina ar piktina – tai veidrodis, rodantis, kur tu pati esi save per daug suvaržiusi. Jis moko tave džiaugtis nežinomybe.

• Pokyčių atspindys: Jis tau rodo, kaip tu jautiesi, kai prarandi situacijos kontrolę. Jei partneris nuolat keičia planus, jis provokuoja tavo lankstumą. Jis moko tave, kad tavo asmeninė jėga (1) nedingsta net ir kintant aplinkybėms.

• Potyrių alkis: Partneris atspindi tavo pačios aistrą gyvenimui. Jis veidrodžiu rodo tą tavo dalį, kuri nori ragauti, keliauti ir eksperimentuoti, užuot sėdėjus vienoje vietoje.

Saugiklis jūsų harmonijai:
Abu esate labai dinamiški, todėl galite pavargti nuo nuolatinio judesio. Jei partneris atrodo pernelyg chaotiškas, tai tavo veidrodis, primenantis: „Sustok ir paklausk savęs – ar aš bėgu link tikslo, ar tiesiog bėgu, kad nereikėtų sustoti?".`,
    // Mirror from 5's perspective (when user is 5, partner is 1)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Vienetas tavo gyvenime atsirado tam, kad tavo laisvą vėją nukreiptų viena kryptimi. Jis atspindi tavo pačios poreikį tapti savo gyvenimo autore ir ne tik ieškoti pokyčių, bet ir juos valdyti.

Veidrodžio principas:

• Valios ir krypties veidrodis: Jei tave erzina partnerio noras vadovauti, tai tavo pačios vidinio chaoso atspindys. Jis moko tave, kad laisvė be tikslo yra tiesiog bėgimas nuo savęs.

• Autoriteto pamoka: Jis tau rodo, kaip tu reaguoji, kai tavo laisvė susiduria su kito žmogaus tvirtu „Aš". Tai tavo pačios asmeninės jėgos veidrodis.

Saugiklis jūsų harmonijai:
Vienetas gali bandyti tave „prisijaukinti". Jei jauti, kad tave riboja, tai tavo veidrodis, sakantis: „Nustok maištauti kaip vaikas; parodyk savo jėgą per brandžius sprendimus".`
  },
  '1-6': {
    attraction: '1 vertina 6 rūpestingumą ir šeimos vertybes. 6 žavisi 1 jėga ir gebėjimu apsaugoti.',
    irritation: '1 gali jaustis "suvaržytas" 6 rūpesčiu. 6 gali jaustis nepakankamai įvertintas ir ignoruojamas.',
    intimacy: 'Švelnus ir jaukus intymumas. 6 sukuria romantiką ir atmosferą, 1 – aistrą. Geriausiai sekasi, kai 1 parodo dėkingumą už 6 pastangas.',
    leisure: '6 mėgsta šeimyninius renginius ir ramų laiką namuose. 1 nori išeiti ir veikti. Kompromisas: savaitgaliai su šeima IR asmeniniai nuotykiai.',
    family: 'Šeimos kūrimas: Idealus šeimos modelis! 6 sukuria šiltą, mylinčią atmosferą, 1 – saugumą ir ambicijas. Vaikai jausis mylimi ir motyvuoti siekti tikslų.',
    finances: 'Finansinis stabilumas: Geras derinys – 1 uždirba, 6 rūpinasi namais ir taupiai tvarko biudžetą. Svarbu, kad 1 vertintų 6 indėlį, net jei jis "nematomas" finansiškai.',
    harmony: 90,
    mirror: `Ką šis žmogus tau atspindi?

Tai lyderio (1) ir globėjo (6) sąjunga. Partneris Šešetas tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su rūpesčiu, šeima ir vidine harmonija. Jis yra tavo emocinio saugumo veidrodis.

Veidrodžio principas:

• Meilės sau ir pasiaukojimo veidrodis: Šešetas tau atspindi tavo pačios poreikį būti reikalingai. Jei jauti naštą dėl partnerio rūpesčio ar lūkesčių – tai veidrodis, rodantis, kur tu pati per daug aukojiesi arba, priešingai, bijai prisiimti atsakomybę už kito jausmus.

• Grožio ir harmonijos atspindys: Jis tau rodo, kaip tu reaguoji į aplinkos estetiką ir ramybę. Jei partnerio siekis „tobulumui" namuose tave erzina, tai tavo pačios vidinio chaoso atspindys, kurį bijai pripažinti.

• Atsakomybės už kitą pamoka: Partneris atspindi tavo gebėjimą derinti savo ambicijas (1) su artimųjų poreikiais. Jis moko tave, kad tikroji galia yra ne tik pasiekti tikslą, bet ir turėti su kuo tuo džiaugsmu pasidalinti.

Saugiklis jūsų harmonijai:
Vienetas gali tapti per daug orientuotas į save, o Šešetas – į kitą. Jei jauti, kad partneris tave „dusina" savo globa, tai tavo veidrodis, sakantis: „Padėkok už meilę ir pasakyk savo poreikius garsiai, užuot kaupusi nepasitenkinimą".`,
    // Mirror from 6's perspective (when user is 6, partner is 1)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Vienetas tavo gyvenime atsirado tam, kad parodytų tavo pačios vidinę jėgą ir gebėjimą nubrėžti ribas. Jis atspindi tavo poreikį būti ne tik globėjai, bet ir savo pačios gyvenimo lyderei.

Veidrodžio principas:

• Asmeninės ašies veidrodis: Jei tave erzina partnerio tiesmukiškumas ar „egoizmas", tai tavo pačios nuolankumo ir baimės pasakyti „ne" atspindys. Jis moko tave, kad meilė kitam prasideda nuo pagarbos savo poreikiams.

• Krypties pamoka: Jis tau rodo, kaip tu reaguoji į ryžtą. Tai tavo pačios gebėjimo siekti tikslų savarankiškai veidrodis.

Saugiklis jūsų harmonijai:
Tu nori harmonijos namuose, jis – pergalių pasaulyje. Jei jauti įtampą, tai tavo veidrodis, sakantis: „Nustok tarnauti jo vizijai; tavo šviesa yra lygiavertė jo ugniai".`
  },
  '1-7': {
    attraction: '1 žavisi 7 išmintimi ir paslaptingumu. 7 vertina 1 jėgą ir aiškumą. Tai intriguojantis derinys – veiksmų žmogus ir mąstytojas.',
    irritation: '7 gali atrodyti per daug uždaras ir neprieinamas. 1 gali atrodyti per daug paviršutiniškas ir nekantrūs. Skirtingi komunikacijos stiliai kelia iššūkių.',
    intimacy: 'Gilus, bet retas intymumas. 7 reikia emocinio saugumo ir laiko atsiverti, 1 – spontaniškumo ir veiksmų. Kai abu atsipalaiduoja, galimas labai gilus, transcendentinis ryšys.',
    leisure: '7 mėgsta tylią veiklą: skaitymas, gamta, meditacija. 1 nori aktyvumo ir nuotykių. Puikus kompromisas: žygiai gamtoje – aktyvumas ir ramybė viename.',
    family: 'Šeimos kūrimas: Kontrastingas, bet galimas modelis. 7 suteikia gylį ir išmintį, 1 – veiksmingumą ir apsaugą. Vaikai augs ir su praktiniais įgūdžiais, ir su filosofiniu požiūriu. Iššūkis: 1 gali jaustis "vienišas" su uždariu 7.',
    finances: 'Finansinis stabilumas: Vidutinis. 1 linkęs rizikuoti ir investuoti, 7 – taupyti ir analizuoti. Geras balansas, jei abu gerbia vienas kito požiūrį. Patarimas: 7 gali padėti 1 priimti apgalvotesnius sprendimus.',
    harmony: 78,
    mirror: `Ką šis žmogus tau atspindi?

Tai veiksmo (1) ir išminties (7) susitikimas. Partneris Septynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios dvasinį gylį ir santykį su vienatve bei tiesos paieškomis.

Veidrodžio principas:

• Vidinės tylos veidrodis: Septynetas tau atspindi tavo pačios baimę likti su savo mintimis. Jei partnerio uždarumas ar poreikis būti vienam tave gąsdina – tai veidrodis, rodantis tavo pačios paviršutiniškumą tam tikrose srityse. Jis moko tave ieškoti atsakymų viduje, o ne išorėje.

• Analitinio proto atspindys: Jis tau rodo, kaip tu reaguoji į gilią analizę ir kritiką. Jei partneris atrodo „per daug mąstantis", tai tavo pačios nekantrumo atspindys. Jis moko tave, kad kokybiškas sprendimas reikalauja laiko ir gilaus supratimo.

• Tikėjimo ir paslapties pamoka: Partneris atspindi tavo pačios paslaptingąją pusę. Jis moko tave, kad ne viskas gyvenime gali būti paaiškinta logika ar pasiekta jėga – egzistuoja aukštesnė tvarka.

Saugiklis jūsų harmonijai:
Vienetas nori aiškumo, Septynetas – paslapties. Jei jauti, kad partneris nuo tavęs tolsta, tai tavo veidrodis, primenantis: „Nustok belstis į uždarytas duris jėga; atsitrauk į savo vidinę tylą ir pamatysi, kaip jis pats tave susiras".`,
    // Mirror from 7's perspective (when user is 7, partner is 1)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Vienetas tavo gyvenime atsirado tam, kad ištrauktų tave iš tavo vidinio urvo ir parodytų tavo pačios ambicijas. Jis atspindi tavo poreikį ne tik analizuoti gyvenimą, bet ir drąsiai jame veikti.

Veidrodžio principas:

• Vidinės ugnies veidrodis: Jei tave erzina partnerio impulsyvumas, tai tavo pačios užslopintos valios atspindys. Jis moko tave, kad tavo išmintis (7) turi tapti matoma per tavo veiksmus (1).

• Autoriteto pamoka: Jis tau rodo, kaip tu reaguoji į išorinį spaudimą. Tai tavo pačios stuburo ir asmeninės tiesos veidrodis.

Saugiklis jūsų harmonijai:
Vienetas gali atrodyti per daug paviršutiniškas tavo gyliui. Jei jauti intelektualinę atskirtį, tai tavo veidrodis, sakantis: „Nustok teisti; tavo partneris yra tavo ryšys su realybe, kurios tau taip reikia".`
  },
  '1-8': {
    attraction: 'Galingas duetas! Abu esate ambiciningi, orientuoti į sėkmę ir gerbiami vienas kito jėgą. Tai "verslo partnerystės" derinys.',
    irritation: 'Valdžios kovos – abu norite būti "bosas". Gali kilti konkurencija vietoj bendradarbiavimo. Abu turite stiprų ego.',
    intimacy: 'Intensyvus ir valdantis intymumas. Abu mėgstate kontrolę, todėl lovoje gali būti "kovų". Geriausiai veikia, kai abu priima lygiateisę partnerystę ir kaitalioja lyderystę.',
    leisure: 'Verslo renginiai, prabangūs restoranai, kelionės pirmąja klase. Abu vertinate statusą ir kokybę. Svarbu rasti laiko be "darbo" kalbų ir tikrai atsipalaiduoti.',
    family: 'Šeimos kūrimas: Galinga, ambicinga šeima. Vaikai augs su dideliais lūkesčiais ir galimybėmis. Rizika: per daug orientacijos į sėkmę, per mažai šilumos. Svarbu: abu turite sąmoningai investuoti į emocinį ryšį.',
    finances: 'Finansinis stabilumas: Puikus! Abu esate orientuoti į turtą ir materialinę sėkmę. Galite kartu sukurti imperiją. Rizika: abu galite per daug rizikuoti. Patarimas: vienas būkite "optimistas", kitas – "kritinis balsas".',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Tai dviejų galios skaičių susidūrimas. Partneris Aštuonetas tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su pinigais, valdžia ir teisingumu. Tai tavo asmeninio autoriteto veidrodis.

Veidrodžio principas:

• Materialinės galios veidrodis: Aštuonetas tau atspindi tavo pačios ambicijas siekti aukštumų. Jei jauti pavydą ar nepasitenkinimą dėl partnerio sėkmės – tai veidrodis, rodantis tavo pačios baimes dėl finansinio saugumo ar nepasitikėjimą savo gebėjimu uždirbti.

• Kontrolės ir dominavimo atspindys: Kadangi abu esate stiprūs, partneris tau rodo tavo pačios polinkį spausti kitus. Jei jauti jo spaudimą, tai tavo pačios elgesio su aplinkiniais atspindys. Jis moko tave lygiavertės partnerystės.

• Karmos ir teisingumo pamoka: Partneris atspindi tavo pačios veiksmų pasekmes. Jis moko tave, kad tavo asmeninė jėga (1) turi būti naudojama ne tik sau, bet ir bendram gėriui kurti.

Saugiklis jūsų harmonijai:
Santykiuose gali prasidėti „karas dėl sosto". Jei jauti įtampą, suprask: partneris yra tavo jėgos atspindys. Vietoj kovos, suvienykite savo resursus – kartu jūs esate nenugalima jėga kuriant materialią gerovę.`,
    // Mirror from 8's perspective (when user is 8, partner is 1)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Vienetas tavo gyvenime atsirado tam, kad parodytų tavo pačios ambicijas ir gebėjimą būti lydere. Jis atspindi tavo poreikį ne tik valdyti resursus, bet ir turėti drąsos pradėti viską nuo nulio.

Veidrodžio principas:

• Asmeninės valios veidrodis: Jei tave erzina partnerio užsispyrimas ar noras viską daryti savaip, tai tavo pačios baimės prarasti kontrolę atspindys. Jis moko tave, kad tikra galia (8) nereikalauja kito slopinimo.

• Iniciatyvos pamoka: Jis tau rodo, kaip tu reaguoji į naujas galimybes. Tai tavo pačios kūrybinės ugnies veidrodis.

Saugiklis jūsų harmonijai:
Jūsų namai gali virsti mūšio lauku dėl valdžios. Jei jauti įtampą, tai tavo veidrodis, sakantis: „Tavo autoritetas nesumažės, jei leisi partneriui vesti. Tikri karaliai moka dalintis sostu".`
  },
  '1-9': {
    attraction: '1 žavisi 9 idealizmu ir didele širdimi. 9 vertina 1 ryžtą ir gebėjimą veikti. Tai "veikėjas + vizionierius" derinys.',
    irritation: '9 gali atrodyti per daug pasiaukojantis ir "ne šiame pasaulyje". 1 gali atrodyti per daug egocentriškas ir materialistiškas 9 akims.',
    intimacy: 'Gilus ir prasmių kupinas intymumas. 9 atneša dvasinį ryšį ir švelnumą, 1 – fizinę aistrą ir iniciatyvą. Kartu galite pasiekti transcendentinį lygį, jei 1 išmoks švelnumo.',
    leisure: '9 mėgsta labdaringą veiklą, meną ir prasmingus projektus. 1 nori asmeninių pasiekimų ir nuotykių. Puikus kompromisas: kartu vadovauti socialiniams ar labdaringiems projektams.',
    family: 'Šeimos kūrimas: Idealios vertybės vaikams – ir ambicija, ir užuojauta. 9 sukuria šiltą, prasmingą atmosferą, 1 – saugumą ir drąsą. Iššūkis: rasti balansą tarp "davimo pasauliui" ir "investavimo į šeimą".',
    finances: 'Finansinis stabilumas: Vidutinis. 1 linkęs kaupti ir investuoti, 9 – aukoti ir dalytis. Reikia aiškaus susitarimo: kiek skiriame sau, kiek – kitiems. Patarimas: sukurkite "labdaros biudžetą", kuris tenkintų 9 poreikius.',
    harmony: 95,
    mirror: `Ką šis žmogus tau atspindi?

Tai ciklo pradžios (1) ir pabaigos (9) sąjunga. Partneris Devynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios gebėjimą paleisti praeitį ir tarnauti didesniam tikslui. Jis yra tavo išminties ir užuojautos veidrodis.

Veidrodžio principas:

• Besąlygiškos meilės veidrodis: Devynetas tau atspindi tavo pačios gebėjimą priimti kitą be išankstinių sąlygų. Jei partnerio idealizmas ar noras padėti visiems aplinkiniams tave erzina – tai veidrodis, rodantis tavo pačios egoizmą ir baimę dalintis savimi.

• Atleidimo pamoka: Partneris tau rodo, kaip tu reaguoji į klaidas (savo ir kitų). Jis yra tavo atleidimo veidrodis. Jis moko tave, kad tavo jėga (1) tampa tikra tik tada, kai ji sušvelninama užuojauta.

• Užbaigimo atspindys: Devynetas padeda tau pamatyti tavo projektų prasmę. Jis moko tave, kad pradėti (1) yra tik pusė darbo – tikrasis meistriškumas yra sugebėti procesą užbaigti su padėka.

Saugiklis jūsų harmonijai:
Vienetas gali būti per daug susikoncentravęs į ateitį, o Devynetas – į žmoniją. Jei jauti, kad partneris per daug atidaro duris svetimiems, tai tavo veidrodis, sakantis: „Išmok matyti plačiau nei tavo asmeniniai tikslai, ir pamatysi, kokį milžinišką pasaulį partneris tau atveria".`,
    // Mirror from 9's perspective (when user is 9, partner is 1)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Vienetas tavo gyvenime atsirado tam, kad primintų tavo pačios asmeninę jėgą ir gebėjimą pradėti naują ciklą po didelio paleidimo. Jis atspindi tavo poreikį ne tik tarnauti kitiems, bet ir nepamiršti savo individualių tikslų.

Veidrodžio principas:

• Veiksmo ir valios veidrodis: Jei tave erzina partnerio tiesmukiškumas ar „egoizmas", tai tavo pačios polinkio per daug aukotis atspindys. Jis moko tave, kad tavo išmintis (9) turi turėti stuburą ir kryptį (1).

• Autoriteto pamoka: Jis tau rodo, kaip tu reaguoji į lyderystę. Tai tavo pačios asmeninio autoriteto veidrodis.

Saugiklis jūsų harmonijai:
Tu nori gelbėti pasaulį, jis – užkariauti savo sritį. Jei jauti atotrūkį, tai tavo veidrodis, sakantis: „Nustok teisti jo ambicijas; jo ugnis yra tai, kas padės tavo vizijoms tapti realybe".`
  },
  // Number 2 combinations
  '2-2': {
    attraction: 'Du jautrūs diplomatai kartu – puikiai suprantate vienas kito emocijas ir poreikius. Tai "sielos draugų" derinys.',
    irritation: 'Per daug pasyvumo – niekas nenori imtis iniciatyvos ar priimti sprendimų. Gali trūkti aiškumo ir krypties. Abu laukiate, kad kitas pirmasis veiktų.',
    intimacy: 'Labai švelnus ir emociškai gilus intymumas. Abu esate jautrūs ir dėmesingi partneriui. Gali trūkti spontaniškumo ir aistros, bet emocinis ryšys – neįkainojamas.',
    leisure: 'Ramūs vakarai namuose, pokalbiai, muzika, menas. Abu vengiate didelių minių ir triukšmo. Svarbu kartais išeiti iš komforto zonos ir patirti kažką naujo kartu.',
    family: 'Šeimos kūrimas: Labai šilta, emociškai saugi šeima. Vaikai augs su dideliu emociniu intelektu ir jautrumu. Rizika: gali trūkti struktūros ir aiškių ribų. Svarbu: abu turite mokytis priimti sprendimus.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę taupyti ir vengti rizikos, bet gali trūkti iniciatyvos investuoti ar auginti turtą. Patarimas: paskirkite vieną iš partnerių finansų "lyderiu" su aiškia atsakomybe.',
    harmony: 70,
    mirror: `Ką šis žmogus tau atspindi?

Kai susitinka du Dvejetai, susiduria du vandenynai. Šis žmogus tavo gyvenime atsirado tam, kad parodytų tavo pačios emocinį gylį, bet kartu ir tavo polinkį į dvejones bei priklausomybę nuo kito nuotaikų.

Veidrodžio principas:

• Emocinio jautrumo veidrodis: Partneris tau atspindi tavo pačios nuotaikų kaitą. Jei tave vargina jo emocingumas ar „auros" svyravimai – tai tavo pačios vidinio nestabilumo atspindys. Jis moko tave rasti ramybę savyje, o ne ieškoti jos kitame.

• Pasyvumo ir laukimo atspindys: Jis tau rodo, kaip atrodo santykis, kai abu laukia iniciatyvos iš kito. Tai veidrodis, verčiantis paklausti: „Ar mes kuriame gyvenimą, ar tik abu plaukiame pasroviui?".

• Intuicijos veidrodis: Partneris atspindi tavo gebėjimą jausti be žodžių. Jis moko tave pasitikėti savo nuojauta, bet tuo pačiu nubrėžti sveikas ribas, kad nesugertum visų kito žmogaus skausmų.

Saugiklis jūsų harmonijai:
Jūsų didžiausias iššūkis – emocinis „pelkėjimas". Jei abu užsidarote tyloje, tai tavo veidrodis, primenantis: „Išdrįsk ištarti tai, kas skauda, net jei tai sugadins laikiną ramybę. Tikra harmonija gimsta iš tiesos, o ne iš nutylėjimų".`
  },
  '2-3': {
    attraction: '2 žavisi 3 linksmumu ir lengvumu. 3 vertina 2 atsidavimą ir emocinį palaikymą. Tai "saulės ir mėnulio" derinys.',
    irritation: '2 gali jaustis ignoruojamas, kai 3 per daug dėmesio skiria socialiniam gyvenimui ir draugams. 3 gali jaustis varžomas 2 emocinio poreikio nuolatiniam dėmesiui.',
    intimacy: 'Žaismingas ir švelnus intymumas. 3 atneša lengvumą, humorą ir kūrybiškumą, 2 – jautrumą ir emocinį gylį. Puikus balansas tarp juoko ir artumo.',
    leisure: '3 nori socialinių renginių ir linksmybių, 2 – ramaus laiko dviese. Puikus kompromisas: kartu eiti į renginius, bet turėti ir "mūsų laiko" be kitų.',
    family: 'Šeimos kūrimas: Linksma ir šilta šeima! 3 atneša optimizmą ir kūrybiškumą, 2 – emocinį saugumą. Vaikai augs ir linksmi, ir emociškai saugūs. Iššūkis: 3 gali jaustis "pririštas" prie namų.',
    finances: 'Finansinis stabilumas: Reikalingas dėmesys. 3 linkęs išleisti ir mėgautis, 2 – taupyti ir rūpintis. Patarimas: 2 turėtų valdyti biudžetą, bet leisti 3 turėti "linksmybių fondą".',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Tai jausmo (2) ir išraiškos (3) sąjunga. Partneris Trejetas tavo gyvenime atsirado tam, kad parodytų tavo pačios poreikį džiaugtis gyvenimu ir išreikšti savo kūrybiškumą, kurį galbūt laikai užrakintą.

Veidrodžio principas:

• Socialumo ir spindėjimo veidrodis: Trejetas tau atspindi tavo pačios poreikį būti pastebėtai. Jei tave erzina jo plepumas ar noras būti dėmesio centre, tai veidrodis, sakantis, kad tu pati sau neleidi pasirodyti pasauliui ir per daug tūnai šešėlyje.

• Žaismingumo pamoka: Jis tau rodo tavo pačios rimtumą. Jei partnerio elgesys atrodo „vaikiškas", tai tavo veidrodis, rodantis, kiek daug džiaugsmo tu prarandi bandydama būti „teisinga" ir „gera".

• Emocinės išraiškos atspindys: Partneris moko tave savo jausmus paversti žodžiais ar kūryba. Jis atspindi tavo dalį, kuri nori dainuoti, šokti ar tiesiog garsiai juoktis.

Saugiklis jūsų harmonijai:
Dvejetas gali tapti Trejeto „šešėliu". Jei jauti, kad partneris pasiima visą eterį, tai tavo veidrodis, primenantis: „Tu esi ne tik palaikytoja, tu esi lygiavertė kūrėja. Išeik į šviesą kartu su juo".`
  },
  '2-4': {
    attraction: 'Abu vertinate stabilumą ir saugumą. 4 suteikia struktūrą, 2 – emocinį šilumą.',
    irritation: 'Gali būti per daug rutinos ir nuobodu. 2 gali jaustis emociškai neišgirstas, 4 – per daug spaudžiamas kalbėti apie jausmus.',
    intimacy: 'Stabilus ir patikimas intymumas. Nėra didelių netikėtumų, bet yra saugumas ir patikimumas. Kartais verta pridėti spontaniškumo.',
    leisure: 'Namai, sodas, ramūs pasivaikščiojimai. Abu mėgstate žinomą ir patikimą aplinką. Svarbu kartais išbandyti kažką naujo.',
    family: 'Šeimos kūrimas: Labai stabili ir saugi šeima. 4 sukuria struktūrą, 2 – emocinę atmosferą. Vaikai augs saugiai ir su aiškiomis ribomis.',
    finances: 'Finansinis stabilumas: Labai geras. Abu linkę taupyti ir planuoti. Kartu sukursite tvirtą finansinį pagrindą.',
    harmony: 92,
    mirror: `Ką šis žmogus tau atspindi?

Tai švelnumo (2) ir tvirtybės (4) sąjunga. Partneris Ketvertas tavo gyvenime atsirado tam, kad parodytų tavo pačios poreikį saugumui ir struktūrai, kurios tau kartais trūksta plaukiant per jausmus.

Veidrodžio principas:

• Stabilumo ir žemiškumo veidrodis: Ketvertas tau atspindi tavo pačios gebėjimą kurti pamatus. Jei jo „sausumas" ar taisyklių laikymasis tave erzina, tai veidrodis, rodantis tavo pačios baimę prisiimti atsakomybę už materialų gyvenimą.

• Kantrybės ir lojalumo atspindys: Jis tau rodo, ką reiškia ištikimybė laikui ir darbui. Partneris atspindi tavo pačios vidinį lojalumą. Jis moko tave, kad meilė yra ne tik jausmas, bet ir kasdienis pasirinkimas statyti bendrus namus.

• Emocinio saugumo pamoka: Jis moko tave įžeminti savo emocijas. Jis yra veidrodis, rodantis, kad jausmai yra saugūs tik tada, kai jie turi aiškias ribas ir kryptį.

Saugiklis jūsų harmonijai:
Jūsų harmonija aukšta, bet Dvejetui gali trūkti romantikos, o Ketvertui – logikos. Jei partneris atrodo per daug šaltas, tai tavo veidrodis, sakantis: „Parodyk jam savo švelnumą be reikalavimų, ir pamatysi, kaip jo sienos pradės tirpti".`
  },
  '2-5': {
    attraction: '2 žavisi 5 laisve ir nuotykių dvasia. 5 vertina 2 stabilumą ir ištikimybę.',
    irritation: '5 gali jaustis "užspaustas" 2 emocinio poreikio. 2 gali jaustis nesaugiai dėl 5 nepriklausomybės.',
    intimacy: 'Kontrastingas – 5 nori eksperimentų ir naujovių, 2 – švelnus ir emocinio artumo. Gali veikti, jei 5 išmoks švelnumo.',
    leisure: '5 nori keliauti ir tyrinėti, 2 – būti kartu namuose. Sunkus kompromisas – abu turite išeiti iš komforto zonos.',
    family: 'Šeimos kūrimas: Iššūkis – skirtingi poreikiai. 2 nori stabilumo, 5 – laisvės. Gali veikti, jei abu bus lankstūs.',
    finances: 'Finansinis stabilumas: Rizikinga. 5 linkęs išleisti nuotykiams, 2 – taupyti. Reikia aiškaus susitarimo.',
    harmony: 65,
    mirror: `Ką šis žmogus tau atspindi?

Tai ramybės (2) ir audros (5) susidūrimas. Partneris Penketas tavo gyvenime atsirado tam, kad parodytų tavo pačios baimę prarasti kontrolę ir tavo prisirišimą prie komforto zonos.

Veidrodžio principas:

• Laisvės ir pokyčių veidrodis: Penketas tau atspindi tavo pačios užslėptą troškimą nuotykiams. Jei jo nenuspėjamumas tave gąsdina, tai veidrodis, rodantis, kiek stipriai tu esi įsikabinusi į praeitį ar saugumą. Jis moko tave lankstumo.

• Nepastovumo pamoka: Jis tau rodo tavo pačios emocinį pažeidžiamumą. Partneris yra tavo veidrodis, verčiantis paklausti: „Ar mano ramybė priklauso nuo aplinkybių, ar aš galiu būti rami net ir audros viduryje?".

• Poreikio erdvei atspindys: Jis moko tave nesisavinti kito žmogaus. Jis atspindi tavo pačios poreikį turėti savo pasaulį už santykių ribų.

Saugiklis jūsų harmonijai:
Dvejetas nori „susilieti", Penketas – „ištrūkti". Jei jauti atstumą, tai tavo veidrodis, sakantis: „Nustok savintis partnerį. Leisk jam skristi, ir jis sugrįš pas tave kaip į savo ramybės uostą".`,
    // Mirror from 5's perspective (when user is 5, partner is 2)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai vėjo ir vandens susitikimas. Partneris Dvejetas atspindi tavo pačios jautrumą, kurį tu dažnai maskuoji naujais potyriais ir nuolatiniu judėjimu.

Veidrodžio principas:

• Emocinio gylio veidrodis: Jei partneris tau atrodo „per daug prilipęs" ar lėtas, tai tavo pačios baimės sustoti ir susidurti su savo jausmais atspindys. Jis moko tave, kad intymumas yra ne laisvės praradimas, o jos gilinimas.

• Ramybės pamoka: Jis tau rodo tavo pačios vidinį nerimą. Tai tavo gebėjimo būti „čia ir dabar" veidrodis.

Saugiklis jūsų harmonijai:
Tu nori skristi, jis nori laikytis už rankų. Jei jauti naštą, tai tavo veidrodis, primenantis: „Tikroji laisvė yra gebėjimas būti saugiam kito glėbyje".`
  },
  '2-6': {
    attraction: 'Harmoningas šeimyninis derinys. Abu vertinate šeimą, rūpestį ir harmoniją.',
    irritation: 'Gali būti per daug aukojimosi kitiems ir per mažai dėmesio sau. Abu galite "perdegti" rūpindamiesi kitais.',
    intimacy: 'Labai švelnus, romantiškus ir rūpestingas intymumas. Abu norite patenkinti partnerį. Tobula harmonija, kai abu jaučiasi saugūs.',
    leisure: 'Šeimos susitikimai, vakarėliai namuose, sodas, kulinarija. Abu kuriate jaukumą ir mėgaujatės namų aplinka.',
    family: 'Šeimos kūrimas: Idealus modelis! Abu sukuria šiltą, mylinčią atmosferą. Vaikai augs su didele meile ir rūpesčiu.',
    finances: 'Finansinis stabilumas: Geras. Abu linkę taupyti šeimai ir namams. Kartu sukursite saugią aplinką.',
    harmony: 95,
    mirror: `Ką šis žmogus tau atspindi?

Tai viena harmoningiausių sąjungų numerologijoje. Partneris Šešetas tavo gyvenime atsirado tam, kad parodytų tavo pačios gebėjimą kurti jaukius namus, puoselėti grožį ir besąlygiškai rūpintis kitais.

Veidrodžio principas:

• Gydančio rūpesčio veidrodis: Šešetas tau atspindi tavo pačios motinišką ar tėvišką energiją. Jei tave vargina jo noras visus „pataisyti" ar globoti, tai veidrodis, rodantis, kur tu pati pamiršti pasirūpinti savimi, atiduodama visą energiją kitiems.

• Harmonijos ir estetikos atspindys: Jis tau rodo tavo pačios poreikį vidinei ir išorinei ramybei. Partneris yra tavo veidrodis, verčiantis paklausti: „Ar aš kuriu grožį aplink save, nes pati jaučiuosi graži viduje, ar tik bandau užmaskuoti vidinį nerimą išoriniu blizgesiu?".

• Atsakomybės už jausmus pamoka: Jis moko tave, kad meilė yra tarnystė. Jis atspindi tavo dalį, kuri randa didžiausią laimę puoselėdama bendrą gerovę ir saugumą.

Saugiklis jūsų harmonijai:
Jūs abu linkę aukotis, todėl galite tapti vienas kito „aukos" veidrodžiais. Jei jauti nuoskaudą, kad „duodi daugiau nei gauni", tai tavo veidrodis, primenantis: „Nustok tarnauti iš baimės būti nereikalinga; tarnauk iš pertekliaus".`,
    // Mirror from 6's perspective (when user is 6, partner is 2)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai viena jautriausių ir šilčiausių sąjungų. Partneris Dvejetas atspindi tavo pačios emocinį gylį ir poreikį besąlygiškam priėmimui.

Veidrodžio principas:

• Emocinio saugumo veidrodis: Jei partneris atrodo „per daug priklausomas", tai tavo pačios baimės likti vienai atspindys. Jis moko tave, kad tikrasis saugumas gimsta iš dviejų širdžių tylaus susitarimo.

• Diplomatijos pamoka: Jis tau rodo tavo pačios kantrybę. Tai tavo gebėjimo jausti kito nuotaikas be žodžių veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu linkę slėpti problemas dėl „ramybės". Jei namuose tampa per daug tylu, tai tavo veidrodis, primenantis: „Išdrįskite sudrumsti vandenį tiesa, kad jūsų meilė netaptų užstovėjusia pelke".`
  },
  '2-7': {
    attraction: '2 žavisi 7 gyliu ir išmintimi. 7 vertina 2 emocinį jautrumą ir supratimą.',
    irritation: '7 gali atrodyti per daug uždaras ir neprieinamas 2 emociniams poreikiams. 2 gali atrodyti per daug "lipnus".',
    intimacy: 'Gilus dvasinis ryšys galimas, bet reikia laiko. 7 turi išmokti atsiverti, 2 – duoti erdvės.',
    leisure: '7 mėgsta tylą ir vienatvę, 2 – buvimą kartu. Kompromisas: tyli veikla kartu – skaitymas, meditacija, gamta.',
    family: 'Šeimos kūrimas: Kontrastingas modelis. 7 suteikia gylį, 2 – emocinę šilumą. Vaikai augs su filosofiniu požiūriu ir emociniu saugumu.',
    finances: 'Finansinis stabilumas: Vidutinis. 7 linkęs analizuoti, 2 – taupyti. Geras balansas.',
    harmony: 80,
    mirror: `Ką šis žmogus tau atspindi?

Tai jausmų (2) ir proto (7) susidūrimas. Partneris Septynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios poreikį giliau pažinti savo vidinį pasaulį ir nebijoti vienatvės tyloje.

Veidrodžio principas:

• Vidinės tiesos veidrodis: Septynetas tau atspindi tavo pačios paslaptis. Jei jo uždarumas tave skaudina, tai veidrodis, rodantis, kad tu pati ne visada esi atvira su savimi. Jis moko tave, kad ne viską reikia pasakyti garsiai, jog tai būtų tikra.

• Dvasinio gylio atspindys: Jis tau rodo tavo pačios santykį su nežinomybe. Jei partnerio analitiškumas tau atrodo „šaltas", tai tavo pačios baimės pasikliauti tik savo jausmais veidrodis. Jis moko tave derinti intuiciją su išmintimi.

• Vienatvės palaimos pamoka: Jis atspindi tavo dalį, kuriai reikia atsiskyrimo. Jis moko tave, kad būti kartu nereiškia būti sulipusiems – tikra sąjunga įmanoma tik tarp dviejų pilnaverčių, savarankiškų asmenybių.

Saugiklis jūsų harmonijai:
Dvejetas nori artumo, Septynetas – erdvės. Jei jauti sieną tarp jūsų, tai tavo veidrodis, sakantis: „Nustok reikalauti emocijų; pasitrauk į savo dvasinę praktiką ir pamatysi, kaip tavo ramybė jį sušildys labiau nei bet kokie žodžiai".`,
    // Mirror from 7's perspective (when user is 7, partner is 2)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai mąstymo ir jausmo susitikimas. Partneris Dvejetas atspindi tavo pačios pažeidžiamumą, kurį tu dažnai slepi po analitika ir uždarumu.

Veidrodžio principas:

• Emocinio artumo veidrodis: Jei partneris atrodo „per daug prilipęs", tai tavo pačios baimės susilieti su kitu žmogumi atspindys. Jis moko tave, kad intelektualinis ryšys be širdies šilumos yra šaltas.

• Intuicijos pamoka: Jis tau rodo tavo pačios sielos kalbą. Tai tavo gebėjimo pasitikėti jausmais, o ne tik faktais, veidrodis.

Saugiklis jūsų harmonijai:
Tu gali užsidaryti savo mintyse ir palikti partnerį vieną. Jei jauti sieną tarp jūsų, tai tavo veidrodis, primenantis: „Išeik iš savo proto į širdį – ten rasi didžiausius atsakymus".`
  },
  '2-8': {
    attraction: '2 žavisi 8 jėga ir sėkme. 8 vertina 2 palaikymą ir ištikimybę.',
    irritation: '8 gali atrodyti per daug užsiėmęs karjera ir ignoruojantis 2 emocinius poreikius. 2 gali atrodyti per daug reikalaujantis.',
    intimacy: '8 atneša aistrą ir intensyvumą, 2 – švelnus ir emocinis. Gerai veikia, kai 8 skiria laiko emociniam ryšiui.',
    leisure: '8 nori verslo renginių ir prabangos, 2 – ramaus laiko kartu. Kompromisas: prabangūs savaitgaliai romantiškoje vietoje.',
    family: 'Šeimos kūrimas: 8 užtikrina finansinį saugumą, 2 – emocinę atmosferą. Geras derinys, jei 8 išmoks skirti laiko šeimai.',
    finances: 'Finansinis stabilumas: Labai geras. 8 uždirba ir investuoja, 2 – valdo namų biudžetą.',
    harmony: 78,
    mirror: `Ką šis žmogus tau atspindi?

Tai jautrumo (2) ir galios (8) balansas. Partneris Aštuonetas tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su pinigais, autoritetu ir gebėjimu pasiekti tai, ko nori, materialiame pasaulyje.

Veidrodžio principas:

• Sėkmės ir vertės veidrodis: Aštuonetas tau atspindi tavo pačios savivertę. Jei jauti jo spaudimą ar dominavimą, tai veidrodis, rodantis, kur tu pati nuvertini savo darbus ir talentus. Jis moko tave būti matomai ir gauti už tai atlygį.

• Kontrolės atspindys: Jis tau rodo, kaip tu reaguoji į griežtą valią. Jei partnerio ambicijos tau atrodo per didelės, tai tavo pačios baimės „turėti per daug" veidrodis. Jis moko tave priimti gausą.

• Teisingumo pamoka: Jis moko tave balanso tarp davimo ir ėmimo. Partneris atspindi tavo gebėjimą būti stipriai, bet išlikti teisingai sau ir kitiems.

Saugiklis jūsų harmonijai:
Jūsų vaidmenys gali tapti „aukos ir budelio". Jei jauti, kad partneris tave kontroliuoja, tai tavo veidrodis, primenantis: „Tavo švelnumas yra tavo jėga, o ne silpnumas. Neleisk savo jausmams tapti manipuliacijos įrankiu – nei tavo, nei jo".`,
    // Mirror from 8's perspective (when user is 8, partner is 2)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai galios ir jautrumo balansas. Partneris Dvejetas atspindi tavo pačios giliai paslėptą švelnumą ir poreikį emociniam saugumui, kurį tu dažnai aukoji dėl sėkmės.

Veidrodžio principas:

• Pažeidžiamumo veidrodis: Jei partneris tau atrodo „per silpnas", tai tavo pačios baimės parodyti savo jausmus atspindys. Jis moko tave, kad tavo širdis yra stipresnė už tavo banko sąskaitą.

• Klausymosi pamoka: Jis tau rodo, kaip tu elgiesi su tais, kurie neturi tavo jėgos. Tai tavo empatijos veidrodis.

Saugiklis jūsų harmonijai:
Tu gali netyčia „pervažiuoti" partnerį savo ambicijomis. Jei jauti atstumą, tai tavo veidrodis, primenantis: „Nustok valdyti, pradėk jausti. Meilė nėra verslo sandoris".`
  },
  '2-9': {
    attraction: 'Abu esate jautrūs ir rūpestingi. Puikiai suprantate vienas kito altruistinę prigimtį.',
    irritation: 'Abu galite per daug aukotis kitiems ir pamiršti savo santykius. Gali trūkti "mes" laiko.',
    intimacy: 'Labai gilus, dvasinis ir emocinis intymumas. Abu ieškote prasmių ir transcendencijos.',
    leisure: 'Labdaringa veikla, dvasinės praktikos, menas. Abu mėgstate prasmingą veiklą, kuri padeda kitiems.',
    family: 'Šeimos kūrimas: Šilta ir prasmingas šeima. Abu sukuria atmosferą, kurioje vaikai mokosi užuojautos ir meilės.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti kitiems. Svarbu rūpintis ir savo finansais.',
    harmony: 90,
    mirror: `Ką šis žmogus tau atspindi?

Tai užuojautos ir sielos giminystės ryšys. Partneris Devynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios gebėjimą atleisti, paleisti praeitį ir tarnauti didesniam tikslui nei tavo asmeniniai poreikiai.

Veidrodžio principas:

• Besąlygiškos užuojautos veidrodis: Devynetas tau atspindi tavo pačios širdies gerumą. Jei jauti pavydą jo „pasaulio gelbėtojo" prigimčiai, tai veidrodis, rodantis tavo pačios poreikį būti svarbesnei už kitus. Jis moko tave meilės be lūkesčių.

• Paleidimo atspindys: Jis tau rodo, kaip tu laikaisi įsikabinusi praeities skausmų. Partneris yra tavo atleidimo veidrodis. Jis moko tave, kad tik paleidusi tai, kas buvo, gali pilnai priimti tai, kas yra dabar.

• Sielos ramybės pamoka: Jis atspindi tavo dalį, kuri supranta visatos dėsnius. Partneris moko tave, kad harmonija (2) pasiekiama tik tada, kai tavo meilė tampa nesavanaudiška.

Saugiklis jūsų harmonijai:
Jūs abu labai jautrūs, todėl galite paskęsti vienas kito emocijose. Jei jauti, kad partneris per daug idealizuoja pasaulį, tai tavo veidrodis, sakantis: „Sustiprink savo vidines ribas. Tavo užuojauta turi turėti stuburą, kad abu nenuskęstumėte kito skausme".`,
    // Mirror from 9's perspective (when user is 9, partner is 2)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai sielos giminystės ir dvasinės partnerystės ryšys. Partneris Dvejetas atspindi tavo pačios poreikį švelnumui, ramybei ir gebėjimui priimti meilę be jokių kaukių.

Veidrodžio principas:

• Emocinio jautrumo veidrodis: Jei partneris tau atrodo „per daug trapus", tai tavo pačios vidinio nuovargio nuo stiprybės atspindys. Jis moko tave, kad tarnystė kitiems negali vykti tavo pačios sielos ramybės sąskaita.

• Intuicijos pamoka: Jis tau rodo tavo pačios gebėjimą jausti be žodžių. Tai tavo emocinio gylio veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu labai sugeriate aplinkos energijas. Jei abu jaučiatės išsekę, tai tavo veidrodis, primenantis: „Sukurkite savo šventovę. Jūsų namai turi būti vieta, kurioje abu pailsite nuo pasaulio skausmo".`
  },
  // Number 3 combinations
  '3-3': {
    attraction: 'Du kūrybingi optimistai kartu! Linksmybės, humoras ir socialinis gyvenimas užtikrintas.',
    irritation: 'Gali trūkti rimtumo ir stabilumo. Abu galite vengti sunkių temų ir atsakomybių.',
    intimacy: 'Labai žaismingas ir kūrybingas intymumas. Daug juoko ir eksperimentavimo. Gali trūkti gilaus emocinio ryšio.',
    leisure: 'Vakarėliai, festivaliai, kelionės, kūrybiniai projektai. Visada yra kažkas įdomaus. Problema: kas tvarkys namų ruošą?',
    family: 'Šeimos kūrimas: Linksma ir kūrybiška šeima! Vaikai augs su dideliu optimizmu. Rizika: gali trūkti struktūros. Svarbu: abu turite mokytis disciplinos.',
    finances: 'Finansinis stabilumas: Rizikinga. Abu linkę išleisti linksmybėms. Būtinas aiškus biudžetas ir "suaugusiojo" vaidmuo.',
    harmony: 80,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Trejetams, įvyksta spalvų sprogimas. Šis žmogus tau rodo tavo pačios džiaugsmą, bet kartu ir tavo polinkį į paviršutiniškumą bei bėgimą nuo problemų per pramogas.

Veidrodžio principas:

• Ekspresijos veidrodis: Jei partneris tau atrodo per daug dramatiškas, tai tavo pačios nesuvaldomų emocijų atspindys. Jis rodo tavo poreikį būti pastebėtai bet kokia kaina.

• Atsakomybės atspindys: Jūs abu rodote vienas kitam, kaip sunku susikaupti ties vienu tikslu. Tai veidrodis, verčiantis paklausti: „Ar mes tik žaidžiame gyvenimą, ar kuriame kažką paliekamo?".

Saugiklis jūsų harmonijai:
Jums gali trūkti „suaugusiojo" energijos. Jei namuose chaosas, tai tavo veidrodis, sakantis: „Šventė baigėsi, laikas pasirūpinti pamatais, kad kitas džiaugsmas turėtų kur sugrįžti".`
  },
  '3-4': {
    attraction: '3 įneša linksmybių į 4 struktūruotą pasaulį. 4 suteikia stabilumo 3 chaosui.',
    irritation: '4 gali atrodyti per daug nuobodus ir standus. 3 gali atrodyti per daug nepatikimas ir lengvabūdiškas.',
    intimacy: 'Kontrastingas – 3 nori spontaniškumo, 4 – rutinos. Gali veikti, jei abu išeis iš komforto zonos.',
    leisure: '3 nori socialinių renginių ir nuotykių, 4 – ramybės namuose. Sunkus kompromisas – reikia aiškaus grafiko.',
    family: 'Šeimos kūrimas: Kontrastingas modelis. 4 sukuria struktūrą, 3 – kūrybą. Vaikai augs su aiškiomis taisyklėmis ir džiaugsmu. Iššūkis: rasti balansą.',
    finances: 'Finansinis stabilumas: Vidutinis. 4 taupo ir planuoja, 3 – išleidžia. 4 turėtų valdyti biudžetą su "kūrybos fondu" 3.',
    harmony: 68,
    mirror: `Ką šis žmogus tau atspindi?

Tai laisvės ir rėmų susidūrimas. Partneris Ketvertas tavo gyvenime atsirado tam, kad parodytų tavo pačios baimę būti apribotai, bet kartu ir tavo didžiulį poreikį būti saugiai.

Veidrodžio principas:

• Drausmės veidrodis: Jei partnerio taisyklės tave siutina, tai tavo pačios baimės suaugti atspindys. Jis moko tave, kad disciplina yra tavo kūrybos laisvės garantas.

• Materialumo pamoka: Jis tau rodo tavo santykį su pinigais ir buitimi. Tai veidrodis, rodantis, kur tu skraidai debesyse, kai tavo kūnui reikia žemės.

Saugiklis jūsų harmonijai:
Tu gali jį laikyti „nuobodu", o jis tave – „vėjavaikiška". Jei jauti atstumą, tai tavo veidrodis, sakantis: „Padėkok jam už stabilumą, kuris leidžia tau kurti saugiai".`
  },
  '3-5': {
    attraction: 'Labai dinamiškas ir jaudinantis derinys! Abu mylite laisvę, nuotykius ir linksmybes.',
    irritation: 'Per daug chaoso ir nepastovumo. Gali trūkti įsipareigojimo ir stabilumo.',
    intimacy: 'Labai aistringas ir eksperimentuojantis. Abu mėgstate naujoves. Gali būti per daug paviršutiniška.',
    leisure: 'Kelionės, festivaliai, nauji restoranai, socialiniai renginiai. Niekada nenuobodžiaujate kartu.',
    family: 'Šeimos kūrimas: Iššūkis – abu mėgstate laisvę. Vaikai gali jaustis nestabiliai. Reikia sukurti "šeimos ritumus" ir nuolatinumo jausmą.',
    finances: 'Finansinis stabilumas: Rizikinga. Abu linkę išleisti. Būtinas "saugus fondas" ekstremaliems atvejams.',
    harmony: 90,
    mirror: `Ką šis žmogus tau atspindi?

Tai nuotykių ir kūrybiškumo fejerverkas. Partneris Penketas atspindi tavo pačios troškimą laisvei, pokyčiams ir nenutrūkstamam gyvenimo skoniui.

Veidrodžio principas:

• Laisvės veidrodis: Jei partneris atrodo nepasiekiamas ar per daug nepriklausomas, tai tavo pačios baimės prisirišti ir būti įsipareigojusiai atspindys.

• Smalsumo pamoka: Jis tau rodo, kiek daug pasaulyje yra galimybių. Jis moko tave niekada nenustoti mokytis ir eksperimentuoti.

Saugiklis jūsų harmonijai:
Jūsų santykiuose gali trūkti gylio dėl nuolatinio lėkimo. Jei pajauti tuštumą, tai tavo veidrodis, primenantis: „Sustokite abudu. Nauji potyriai neužpildys sielos, jei nemokėsite tylėti kartu".`,
    // Mirror from 5's perspective (when user is 5, partner is 3)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai kūrybinis fejerverkas! Partneris Trejetas atspindi tavo pačios džiaugsmą, charizmą ir poreikį žaisti gyvenimą.

Veidrodžio principas:

• Saviraiškos veidrodis: Jei tave erzina jo plepumas ar dėmesio siekimas, tai tavo pačios nerealizuoto kūrybiškumo atspindys. Jis moko tave spindėti be pateisinimų.

• Lengvumo pamoka: Jis tau rodo, kad gyvenimas yra nuotykis, kurį reikia ne tik patirti, bet ir juo pasidalinti su kitais.

Saugiklis jūsų harmonijai:
Jums abiem gali trūkti atsakomybės jausmo. Jei gyvenimas virsta chaosu, tai tavo veidrodis, sakantis: „Šventėms reikia namų. Sukurkite bent minimalią struktūrą, kad jūsų džiaugsmas neišgaruotų".`
  },
  '3-6': {
    attraction: '3 įneša linksmybių, 6 – šilumos ir rūpesčio. Harmoningas ir malonus derinys.',
    irritation: '6 gali jaustis nepakankamai įvertintas už savo rūpestį. 3 gali jaustis varžomas 6 lūkesčių.',
    intimacy: 'Švelnus ir romantiškus su žaismingumo prieskonio. 6 kuria aplinką, 3 – nuotaiką.',
    leisure: 'Šeimos šventės, vakarėliai su draugais, kūrybiniai projektai namuose. Abu mėgstate socialumą su šeimos jausmu.',
    family: 'Šeimos kūrimas: Idealus modelis! 6 sukuria šiltą atmosferą, 3 – džiaugsmą. Vaikai augs mylimi ir laimingi.',
    finances: 'Finansinis stabilumas: Geras. 6 rūpinasi namais, 3 gali uždirbti iš kūrybos. Svarbu, kad 3 vertintų 6 indėlį.',
    harmony: 94,
    mirror: `Ką šis žmogus tau atspindi?

Tai meilės ir džiaugsmo derinys. Partneris Šešetas tavo gyvenime atspindi tavo pačios vidinį grožį ir poreikį sukurti harmoningą erdvę savo kūrybai.

Veidrodžio principas:

• Besąlygiškos meilės veidrodis: Šešetas tau rodo tavo pačios poreikį būti globojamai. Jis moko tave priimti meilę be jokių kaukių ir pasirodymų.

• Atsakomybės už šeimą pamoka: Jis tau rodo tavo pačios norą priklausyti bendruomenei. Tai tavo empatijos ir dosnumo veidrodis.

Saugiklis jūsų harmonijai:
Trejetas gali tapti egoistiškas, o Šešetas – kontroliuojantis. Jei jauti spaudimą, tai tavo veidrodis, sakantis: „Tavo džiaugsmas turi maitinti šeimą, o ne tik tavo ego".`,
    // Mirror from 6's perspective (when user is 6, partner is 3)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Trejetas yra tavo vidinio džiaugsmo ir kūrybinio lengvumo veidrodis. Jis tavo gyvenime atsirado tam, kad parodytų tavo pačios per didelį atsakomybės jausmą ir poreikį būti „tobulai".

Veidrodžio principas:

• Žaismingumo veidrodis: Jei jo nerūpestingumas tave erzina, tai tavo pačios suvaržyto vaiko atspindys. Jis moko tave meilę paversti švente, o ne tik pareiga.

• Saviraiškos pamoka: Jis tau rodo, kiek daug spalvų tu turi savo viduje. Tai tavo pačios kūrybiškumo veidrodis.

Saugiklis jūsų harmonijai:
Tu rūpiniesi buitimi, jis – nuotaika. Jei jauti nuoskaudą, tai tavo veidrodis, sakantis: „Nustok būti tik mama ar šeimininke; tapk jo mūza ir leisk sau džiaugtis kartu".`
  },
  '3-7': {
    attraction: '3 žavisi 7 paslaptingumu. 7 vertina 3 lengvumą, kuris padeda atsipalaiduoti.',
    irritation: '7 gali jaustis išsekęs nuo 3 socialumo. 3 gali jaustis ignoruojamas dėl 7 uždarumo.',
    intimacy: 'Sunkus derinys – 3 nori lengvumo ir žaismingumo, 7 – gilumo ir prasmių. Reikia daug komunikacijos.',
    leisure: '3 nori socialinių renginių, 7 – tylos ir vienatvės. Labai sunkus kompromisas.',
    family: 'Šeimos kūrimas: Kontrastingas modelis. 3 sukuria džiaugsmą, 7 – gylį. Vaikai augs su filosofiniu požiūriu ir optimizmu. Iššūkis: susikalbėti tarpusavyje.',
    finances: 'Finansinis stabilumas: Vidutinis. 7 analizuoja, 3 – išleidžia. 7 turėtų valdyti strateginius sprendimus.',
    harmony: 65,
    mirror: `Ką šis žmogus tau atspindi?

Tai paviršiaus ir gelmės susitikimas. Partneris Septynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios baimę likti tyloje su savo mintimis.

Veidrodžio principas:

• Išminties veidrodis: Jei partnerio uždarumas tave erzina, tai tavo pačios baimės susidurti su savo vidine tamsa atspindys. Jis moko tave, kad tikroji tiesa yra ne žodžiuose, o anapus jų.

• Vienatvės pamoka: Jis tau rodo, kaip tu jautiesi, kai nesi dėmesio centre. Tai tavo dvasinės brandos veidrodis.

Saugiklis jūsų harmonijai:
Tu nori kalbėti, jis nori tylėti. Jei jauti sieną, tai tavo veidrodis, sakantis: „Nustok užpildyti erdvę žodžiais. Pabandyk išgirsti jo tylą ir ten rasi didžiausią lobį".`,
    // Mirror from 7's perspective (when user is 7, partner is 3)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Trejetas yra tavo vidinio džiaugsmo ir lengvabūdiškumo veidrodis. Jis tavo gyvenime atsirado tam, kad parodytų tavo pačios perdėtą rimtumą ir polinkį į izoliaciją.

Veidrodžio principas:

• Saviraiškos veidrodis: Jei jo plepumas tave erzina, tai tavo pačios baimės būti pastebėtai ir nesuprastai atspindys.

• Lengvumo pamoka: Jis tau rodo, kad gyvenimas yra ne tik studija, bet ir žaidimas. Tai tavo pačios nerealizuoto humoro veidrodis.

Saugiklis jūsų harmonijai:
Tu nori gylio, jis – šventės. Jei jauti trintį, tai tavo veidrodis, sakantis: „Nusiimk išminčiaus kaukę ir tiesiog pasijuok kartu – tai geriausia meditacija tavo sielai".`
  },
  '3-8': {
    attraction: '3 įneša linksmybių į 8 rimtą pasaulį. 8 suteikia stabilumo ir statuso 3 kūrybiškumui.',
    irritation: '8 gali atrodyti per daug rimtas ir orientuotas į darbą. 3 gali atrodyti per daug lengvabūdiškas.',
    intimacy: '8 atneša intensyvumą, 3 – žaismingumą. Geras derinys, kai abu atsipalaiduoja.',
    leisure: '8 mėgsta prabangą ir verslo renginius, 3 – kūrybinius projektus ir linksmybes. Kompromisas: prabangūs kultūriniai renginiai.',
    family: 'Šeimos kūrimas: Potencialu stipri šeima. 8 užtikrina finansinį saugumą, 3 – džiaugsmą. Vaikai augs ir su ambicijomis, ir su optimizmu.',
    finances: 'Finansinis stabilumas: Geras. 8 uždirba ir investuoja, 3 gali uždirbti iš kūrybos. Svarbu, kad 8 neignoruotų 3 indėlio.',
    harmony: 82,
    mirror: `Ką šis žmogus tau atspindi?

Tai džiaugsmo (3) ir valdžios (8) derinys. Partneris Aštuonetas atspindi tavo pačios santykį su pripažinimu, statusu ir materialiu sėkmės įvertinimu.

Veidrodžio principas:

• Autoriteto veidrodis: Jei jauti spaudimą iš partnerio, tai tavo pačios nerealizuotos jėgos atspindys. Jis moko tave savo kūrybą paversti pelnu.

• Teisingumo pamoka: Jis tau rodo, kaip tu elgiesi su galia. Partneris moko tave balanso tarp žaidimo ir rimtų rezultatų siekimo.

Saugiklis jūsų harmonijai:
Jūsų ambicijos gali susidurti. Jei partneris atrodo per daug „šaltas verslininkas", tai tavo veidrodis, primenantis: „Tavo šypsena yra tavo didžiausia valiuta, nepamiršk jos darbuose".`,
    // Mirror from 8's perspective (when user is 8, partner is 3)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Trejetas yra tavo vidinio džiaugsmo ir kūrybiškumo veidrodis. Jis tavo gyvenime atsirado tam, kad parodytų, jog sėkmė be džiaugsmo yra tuščia.

Veidrodžio principas:

• Spontaniškumo veidrodis: Jei partnerio lengvabūdiškumas tave piktina, tai tavo pačios per didelio rimtumo ir įtampos atspindys. Jis moko tave švęsti savo pasiekimus.

• Saviraiškos pamoka: Jis tau rodo, kad galia gali būti žaisminga. Tai tavo pačios nerealizuoto kūrybiškumo veidrodis.

Saugiklis jūsų harmonijai:
Jūs galite tapti „prestižine pora", kuriai rūpi tik įvaizdis. Jei jauti tuštumą, tai tavo veidrodis, sakantis: „Nusiimkite kaukes. Tikra laimė yra ne tai, ką apie jus galvoja kiti, o tai, kaip jūs jaučiatės likę dviese".`
  },
  '3-9': {
    attraction: 'Abu esate kūrybingi ir idealistiniai. Kartu galite įkvėpti pasaulį.',
    irritation: 'Gali trūkti praktiškumo ir įžeminimo. Abu galite gyventi savo sapnų pasaulyje.',
    intimacy: 'Kūrybingas ir dvasinis intymumas. Abu ieškote prasmių ir grožio.',
    leisure: 'Menas, teatras, kūrybiniai projektai, kelionės. Abu mėgstate įkvėpiančią veiklą.',
    family: 'Šeimos kūrimas: Kūrybinga ir idealistinė šeima. Vaikai augs su meile menui ir humanizmui. Iššūkis: įžeminti svajonės.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti idėjoms. Svarbu turėti praktišką finansų planą.',
    harmony: 96,
    mirror: `Ką šis žmogus tau atspindi?

Tai sielos skrydis. Partneris Devynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios gebėjimą matyti visumą, užjausti ir tarnauti pasauliui per savo kūrybiškumą.

Veidrodžio principas:

• Išminties ir užbaigimo veidrodis: Devynetas tau rodo, kad tavo idėjos (3) turi prasmę tik tada, kai jos kam nors padeda (9). Jis moko tave altruizmo.

• Paleidimo pamoka: Jis tau rodo tavo pačios prisirišimą prie savo įvaizdžio. Tai tavo nuolankumo ir dvasinio skrydžio veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu galite „išskristi" iš realybės. Jei jauti, kad prarandate žemę, tai tavo veidrodis, sakantis: „Jūsų misija didelė, bet jai reikia jūsų abiejų buvimo čia ir dabar".`,
    // Mirror from 9's perspective (when user is 9, partner is 3)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Trejetas yra tavo džiaugsmo ir kūrybinio pakylėjimo veidrodis. Jis tavo gyvenime atsirado tam, kad parodytų tavo pačios sielos šventę, kurią dažnai nustumi dėl savo rimtų dvasinių misijų.

Veidrodžio principas:

• Žaismingumo veidrodis: Jei jo nerūpestingumas tave erzina, tai tavo pačios suvaržyto vidinio vaiko atspindys.

• Išraiškos pamoka: Jis tau rodo, kad sielos tiesa gali būti perduodama per džiaugsmą ir spalvas. Tai tavo pačios kūrybiškumo veidrodis.

Saugiklis jūsų harmonijai:
Jūs galite kartu pasiklysti idealuose. Jei jauti, kad praradote žemę, tai tavo veidrodis, sakantis: „Mėgaukitės vienas kitu dabar, o ne tik tada, kai pasaulis bus tobulas".`
  },
  // Number 4 combinations
  '4-4': {
    attraction: 'Du patikimi ir stabilūs žmonės kartu. Tvirtumas ir saugumas garantuotas.',
    irritation: 'Gali būti per daug rutinos ir standžių. Abu galite priešintis pokyčiams.',
    intimacy: 'Stabilus ir patikimas, bet gali trūkti spontaniškumo. Abu žinote, ko tikėtis.',
    leisure: 'Namai, sodas, remontai, tradiciniai renginiai. Abu vertinate struktūrą ir tvarką.',
    family: 'Šeimos kūrimas: Labai stabili šeima su aiškiomis taisyklėmis. Vaikai augs saugiai. Rizika: gali trūkti lankstumo ir spontaniškumo.',
    finances: 'Finansinis stabilumas: Labai geras. Abu taupote ir planuojate. Kartu sukursite tvirtą finansinį pagrindą.',
    harmony: 75,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Ketvertams, susitinka dvi uolos. Šis partneris atspindi tavo pačios poreikį stabilumui, bet kartu ir tavo polinkį į sąstingį bei baimę keistis.

Veidrodžio principas:

• Drausmės ir užsispyrimo veidrodis: Jei tave erzina partnerio nelankstumas, tai tavo pačios „betoninių" nuostatų atspindys.

• Saugumo iliuzijos veidrodis: Jūs abu rodote vienas kitam, kaip sunku paleisti kontrolę. Tai veidrodis, verčiantis paklausti: „Ar mes gyvename, ar tik statome bunkerį?".

Saugiklis jūsų harmonijai:
Jūsų namai gali tapti tylūs ir sunkūs. Jei jauti monotoniją, tai tavo veidrodis, sakantis: „Išgriaukite vieną sieną – įsileiskite naujų patirčių, kad jūsų pamatai nepradėtų skilti nuo svorio".`
  },
  '4-5': {
    attraction: '4 siūlo stabilumą, kurio 5 viduje ieško. 5 atneša jaudinimą į 4 gyvenimą.',
    irritation: 'Labai sudėtingas derinys. 4 jaučiasi nestabilus su 5, 5 jaučiasi kalinys su 4.',
    intimacy: 'Kontrastingas – 4 nori rutinos, 5 – nuotykių. Reikia daug kompromisų.',
    leisure: '4 nori namuose, 5 – keliauti. Vienas sunkiausių kompromisų visoje numerologijoje.',
    family: 'Šeimos kūrimas: Iššūkis – skirtingi poreikiai. 4 nori stabilumo, 5 – laisvės. Vaikai gali jaustis tarp dviejų pasaulių.',
    finances: 'Finansinis stabilumas: Rizikinga. 4 taupo, 5 – išleidžia. Reikia aiškaus susitarimo ir atskiro "nuotykių fondo".',
    harmony: 60,
    mirror: `Ką šis žmogus tau atspindi?

Tai tavo pačios didžiausių baimių ir didžiausios laisvės veidrodis. Partneris Penketas tavo gyvenime atsirado tam, kad išmokytų tave skristi, kai tu nori tik stovėti.

Veidrodžio principas:

• Pokyčių veidrodis: Jei jo nenuspėjamumas tave gąsdina, tai tavo pačios baimės prarasti pamatus atspindys. Jis moko tave lankstumo.

• Laisvės pamoka: Jis tau rodo, kiek daug tu prarandi saugodama tai, kas seniai nebeveikia. Tai tavo pačios suvaržytos prigimties veidrodis.

Saugiklis jūsų harmonijai:
Tu nori garantijų, jis – nuotykių. Jei jauti prarają, tai tavo veidrodis, sakantis: „Nustok savintis jo laiką. Leisk jam būti vėju, o tu būk jo saugiu uostu, į kurį visada norisi sugrįžti".`,
    // Mirror from 5's perspective (when user is 5, partner is 4)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai didžiausias tavo iššūkis. Partneris Ketvertas atspindi tavo pačios baimę būti „įžemintai" ir tavo šešėlinį poreikį stabilumui, kurį tu neigi.

Veidrodžio principas:

• Saugumo ir rėmų veidrodis: Jei partnerio taisyklės tave siutina, tai tavo pačios baimės prisiimti ilgalaikę atsakomybę atspindys. Jis moko tave, kad šaknys leidžia skristi aukščiau.

• Drausmės pamoka: Jis tau rodo tavo pačios nepastovumą. Tai tavo gebėjimo užbaigti tai, ką pradejai, veidrodis.

Saugiklis jūsų harmonijai:
Tu jį matai kaip „kalėjimą", jis tave – kaip „pavojų". Jei jauti sieną, tai tavo veidrodis, sakantis: „Pripažink, kad tau reikia jo stabilumo, jog tavo laisvė netaptų destruktyvi".`
  },
  '4-6': {
    attraction: 'Abu vertinate šeimą, namus ir stabilumą. Puikus pagrindas tvirtai šeimai.',
    irritation: 'Gali trūkti spontaniškumo ir nuotykių. Abu galite tapti per daug "nuobodūs".',
    intimacy: 'Švelnus, patikimas ir rūpestingas. Abu norite patenkinti partnerį.',
    leisure: 'Šeimos susitikimai, darbai namuose, sodas. Abu kuriate stabilią ir jaukią aplinką.',
    family: 'Šeimos kūrimas: Idealus pagrindas tvirtai šeimai! Abu vertinate tradicijas ir stabilumą. Vaikai augs saugioje, mylinčioje aplinkoje su aiškiomis vertybėmis.',
    finances: 'Finansinis stabilumas: Labai geras. Abu esate atsakingi ir taupūs. 4 kuria struktūrą, 6 rūpinasi namų jaukumu. Kartu sukursite finansiškai stabilius namus.',
    harmony: 88,
    mirror: `Ką šis žmogus tau atspindi?

Tai tradicijų ir meilės veidrodis. Partneris Šešetas atspindi tavo pačios poreikį harmonijai, šeimai ir estetikai, kurią tu kartais pamiršti dėl pragmatiškumo.

Veidrodžio principas:

• Rūpesčio ir grožio veidrodis: Jei partnerio reikalavimai „jaukumui" tave erzina, tai tavo pačios vidinio sausumo atspindys. Jis moko tave, kad tvarka turi tarnauti žmogui, o ne žmogus tvarkai.

• Atsakomybės už kitą pamoka: Jis tau rodo tavo pačios gebėjimą mylėti be sąlygų.

Saugiklis jūsų harmonijai:
Abu galite tapti per daug rimti. Jei namuose tampa per „teisinga", tai tavo veidrodis, sakantis: „Leiskite sau klysti, tavo meilė yra stipresnė už tavo taisykles".`,
    // Mirror from 6's perspective (when user is 6, partner is 4)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai tradicijų ir stabilumo sąjunga. Partneris Ketvertas tavo gyvenime atspindi tavo pačios poreikį tvirtam pagrindui ir materialiam saugumui.

Veidrodžio principas:

• Drausmės ir taisyklių veidrodis: Jei partnerio „sausumas" tave dusina, tai tavo pačios baimės prarasti kontrolę atspindys. Jis moko tave, kad meilė turi turėti namus ir struktūrą.

• Ištikimybės pamoka: Jis tau rodo, ką reiškia statyti santykius plyta po plytos. Tai tavo pačios kantrybės veidrodis.

Saugiklis jūsų harmonijai:
Jūsų gyvenimas gali virsti pareigų sąrašu. Jei jauti monotoniją, tai tavo veidrodis, sakantis: „Įnešk į jūsų tvarką daugiau šilumos. Taisyklės be švelnumo tėra šalti rėmai".`
  },
  '4-7': {
    attraction: '4 vertina 7 išmintį. 7 vertina 4 patikimumą ir struktūrą.',
    irritation: 'Gali būti per daug uždarumo ir komunikacijos trūkumo. Abu mėgstate tylą.',
    intimacy: 'Gilus, bet retas. Abu reikia laiko atsipalaiduoti ir atsiverti.',
    leisure: 'Ramus laikas namuose, skaitymas, gamta. Abu mėgstate tylią, prasmingą veiklą.',
    family: 'Šeimos kūrimas: Rami, stabili šeima su giliu dvasiniu pagrindu. 4 sukuria struktūrą, 7 – išmintį. Vaikai augs su praktiškumu ir filosofiniu požiūriu.',
    finances: 'Finansinis stabilumas: Geras. 4 taupo ir planuoja, 7 – analizuoja investicijas. Abu vengia rizikos ir priima apgalvotus sprendimus.',
    harmony: 80,
    mirror: `Ką šis žmogus tau atspindi?

Tai materijos (4) ir dvasios (7) susitikimas. Partneris Septynetas atspindi tavo pačios poreikį atsakymams, kurie yra anapus matomo pasaulio.

Veidrodžio principas:

• Vienatvės ir išminties veidrodis: Jei partnerio atsiribojimas tave skaudina, tai tavo pačios baimės likti su savimi atspindys. Jis moko tave ieškoti prasmės tyla.

• Analitikos pamoka: Jis tau rodo, kaip tu reaguoji į tai, ko negali sukontroliuoti logika.

Saugiklis jūsų harmonijai:
Jums gali trūkti bendro ryšio materialiame pasaulyje. Jei jauti sieną, tai tavo veidrodis, sakantis: „Pripažink jo dvasinį gylį ir pamatysi, kaip tavo pamatai taps dar tvirtesni".`,
    // Mirror from 7's perspective (when user is 7, partner is 4)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai dvasios (7) ir materijos (4) sąjunga. Partneris Ketvertas tavo gyvenime atspindi tavo pačios poreikį įžeminti savo idėjas ir suteikti joms formą.

Veidrodžio principas:

• Drausmės ir buities veidrodis: Jei partnerio pragmatiškumas tave slegia, tai tavo pačios baimės prisiimti atsakomybę už materialią būtį atspindys.

• Saugumo pamoka: Jis tau rodo, kad dvasinė ramybė reikalauja materialaus pagrindo. Tai tavo pačios gebėjimo statyti namus veidrodis.

Saugiklis jūsų harmonijai:
Galite tapti dviem atskirai gyvenančiomis salomis. Jei jauti monotoniją, tai tavo veidrodis, sakantis: „Pabandyk paaiškinti jam savo pasaulį paprastais žodžiais – jis padės tau jį įtvirtinti realybėje".`
  },
  '4-8': {
    attraction: 'Galingas materialinės sėkmės derinys! Abu esate orientuoti į tikslus ir pasiekimus.',
    irritation: 'Gali trūkti emocinio artumo ir spontaniškumo. Gyvenimas gali tapti "verslo planu".',
    intimacy: 'Struktūruotas ir orientuotas į tikslus. Gali trūkti romantikos, bet yra patikimumas.',
    leisure: 'Verslo renginiai, investicijos, nekilnojamojo turto projektai. Abu mėgstate "produktyvų" poilsį.',
    family: 'Šeimos kūrimas: Galinga, ambicinga šeima. Vaikai augs su dideliais lūkesčiais ir galimybėmis. Svarbu nepritrūkti emocinio artumo.',
    finances: 'Finansinis stabilumas: Puikus! Abu esate orientuoti į materialinę sėkmę. 4 stato pamatus, 8 – kuria imperiją. Kartu galite pasiekti didelių finansinių tikslų.',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Tai dviejų darbininkų ir kūrėjų sąjunga. Partneris Aštuonetas atspindi tavo pačios ambicijas ir gebėjimą sukurti milžinišką vertę materialiame pasaulyje.

Veidrodžio principas:

• Sėkmės ir statuso veidrodis: Jei partnerio dominavimas tave slegia, tai tavo pačios nerealizuotos jėgos atspindys.

• Teisingumo pamoka: Jis tau rodo tavo požiūrį į valdžią. Tai tavo pačios vidinio autoriteto veidrodis.

Saugiklis jūsų harmonijai:
Jūsų gyvenimas gali virsti verslo planu. Jei jauti, kad neliko meilės, tik darbai, tai tavo veidrodis, primenantis: „Nepamiršk širdies, jokia imperija nėra verta tavo sielos ramybės".`,
    // Mirror from 8's perspective (when user is 8, partner is 4)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai dviejų statytojų sąjunga. Partneris Ketvertas tavo gyvenime atspindi tavo pačios poreikį stabilumui ir kantrybei siekiant didelių tikslų.

Veidrodžio principas:

• Drausmės ir kantrybės veidrodis: Jei partnerio lėtumas tave erzina, tai tavo pačios baimės nepasiekti rezultato greitai atspindys. Jis moko tave statyti imperiją plyta po plytos.

• Saugumo pamoka: Jis tau rodo tavo pačios santykį su detalėmis ir tvarka. Tai tavo gebėjimo išlaikyti tai, ką sukūrei, veidrodis.

Saugiklis jūsų harmonijai:
Jūsų santykiai gali tapti nuolatiniu darbu. Jei pamiršote romantiką, tai tavo veidrodis, sakantis: „Išeikite atostogų be telefonų. Jūsų namai nesugrius, jei vieną vakarą tiesiog būsite vyras ir moteris".`
  },
  '4-9': {
    attraction: '4 siūlo struktūrą 9 idealistinėms vizijoms. 9 įkvepia 4 didesniam tikslui.',
    irritation: '9 gali atrodyti per daug "ne šiame pasaulyje". 4 gali atrodyti per daug prisirišęs prie materialių dalykų.',
    intimacy: 'Gilus ir prasmingas, kai abu randa bendrą kalbą. Reikia laiko suprasti vienas kitą.',
    leisure: '4 nori praktinės veiklos, 9 – prasmingos. Kompromisas: kartu savanoriauti ar dirbti labdaros projektuose.',
    family: 'Šeimos kūrimas: Prasminga šeima su praktišku ir idealistiniu pagrindu. 4 sukuria stabilumą, 9 – vertybes. Vaikai augs su atsakomybės jausmu ir užuojauta.',
    finances: 'Finansinis stabilumas: Vidutinis. 4 nori kaupti, 9 – dalytis. Reikia aiškaus susitarimo, kiek skirti sau ir kiek – kitiems.',
    harmony: 72,
    mirror: `Ką šis žmogus tau atspindi?

Tai žemės (4) ir dangaus (9) susitikimas. Partneris Devynetas atspindi tavo pačios poreikį pasiaukojimui ir platesniam matymui.

Veidrodžio principas:

• Paleidimo veidrodis: Jei jo idealizmas tau atrodo neracionalus, tai tavo pačios godumo ar prisirišimo prie daiktų atspindys.

• Užuojautos pamoka: Jis tau rodo, kad tavo tvarka turi tarnauti visų gėriui, o ne tik tavo saugumui.

Saugiklis jūsų harmonijai:
Tu nori kaupti ateičiai, jis nori atiduoti dabar. Jei jauti konfliktą, tai tavo veidrodis, sakantis: „Atidaryk savo širdį platesniam pasauliui – ten tavo saugumas ras tikrąją prasmę".`,
    // Mirror from 9's perspective (when user is 9, partner is 4)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai dangaus ir žemės susitikimas. Partneris Ketvertas tavo gyvenime atspindi tavo pačios poreikį disciplinai ir gebėjimą savo gilias vizijas įkūnyti materialiame pavidale.

Veidrodžio principas:

• Atsakomybės ir formos veidrodis: Jei partnerio griežtumas tave dusina, tai tavo pačios baimės prisiimti atsakomybę už žemišką būtį atspindys.

• Kantrybės pamoka: Jis tau rodo, kaip tu reaguoji į ribas. Tai tavo pačios kantrybės ir nuolankumo veidrodis.

Saugiklis jūsų harmonijai:
Tu nori atiduoti viską kitiems, jis nori kaupti pamatus. Jei jauti konfliktą, tai tavo veidrodis, sakantis: „Padėkok jam už stabilumą; be jo tavo meilė tiesiog išgaruotų be pėdsako".`
  },
  // Number 5 combinations
  '5-5': {
    attraction: 'Du nuotykių ieškotojai kartu! Niekada nenuobodžiaujate ir visada yra kažkas naujo. Abu esate laisvės dvasios, nešančios Penketo energiją.',
    irritation: 'Gali trūkti stabilumo ir įsipareigojimo. Abu galite bijoti rutinos. Jūsų veidrodinis atspindys gali būti toks ryškus, kad kartais norėsis nusukti akis.',
    intimacy: 'Labai aistringas ir eksperimentuojantis. Abu mėgstate naujoves ir intensyvius pojūčius.',
    leisure: 'Kelionės, festivaliai, nauji restoranai, sportas. Visada ieškote kito nuotykio.',
    family: 'Šeimos kūrimas: Jūsų didžiausias iššūkis – stabilumas. Jums abu reikės sąmoningai investuoti į namus kaip saugią bazę, nuo kurios galite leistis į nuotykius ir sugrįžti.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu esate linkę rizikuoti ir ieškoti naujų galimybių. Svarbu turėti bent vieną "stabilų" investicinį planą šalia visų nuotykių.',
    mirror: `Ką šis žmogus tau atspindi?

Kai susitinka du žmonės, nešantys Penketo energiją, jie tampa vienas kito Laisvės ir Chaoso veidrodžiais. Šis žmogus tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su pokyčiais ir vidiniu nerimu.

1. Laisvės atspindys:
Partneris tau primena tavo pačios prigimtinį poreikį būti nepriklausomai. Jei jauti erzulį, kai jis bando ištrūkti iš rėmų ar elgtis spontaniškai – tai veidrodis, rodantis, kur tu pati sau draudi būti laisva. Jis tave moko, kad meilė nėra kalėjimas, o du laisvi paukščiai, skrendantys viena kryptimi.

2. Veidrodinis nerimas:
Penketai yra judrūs ir greiti. Jei matai partnerį nuolat skubantį, ieškantį naujų potyrių ar negalintį nusėdėti vietoje – jis tau "veidrodžiu" rodo tavo pačios vidinį chaosą. Jis provokuoja tave paklausti: "Ar aš bėgu link kažko, ar bėgu nuo savęs?".

3. Jausmų intensyvumas:
Šiame santykyje partneris atspindi tavo aistrą gyvenimui. Jis yra tavo drąsos veidrodis. Tai, kuo žaviesi jame (drąsa keisti, keliauti, eksperimentuoti), yra tai, ką tu turi savyje, bet galbūt buvai prigesinusi dėl "reikia" ar "privalau".

Saugiklis jūsų harmonijai:
Kadangi abu esate Penketai, jūsų didžiausias iššūkis – stabilumas. Jūsų veidrodinis atspindys gali būti toks ryškus, kad kartais norėsis nusukti akis. Atminkite: kai partneris tave erzina savo "nepastovumu", jis tiesiog rodo tavo pačios baimę sustoti ir susidurti su tyla.`
  },
  '5-6': {
    attraction: '5 įneša jaudinimo, 6 – šilumos ir stabilumo. Galimas balansas.',
    irritation: '5 gali jaustis "užspaustas" 6 šeimyniniais lūkesčiais. 6 gali jaustis nesaugiai dėl 5 laisvės poreikio.',
    intimacy: '5 atneša aistrą ir naujoves, 6 – švelnumą ir rūpestį. Gali veikti su kompromisais.',
    leisure: '5 nori keliauti ir tyrinėti, 6 – būti su šeima. Kompromisas: šeimos kelionės.',
    family: 'Šeimos kūrimas: Iššūkis – 5 nori laisvės, 6 – šeimyninio stabilumo. Vaikai gali jausti šį kontrastą. Raktas: 5 turi įsipareigoti šeimos ritualams, o 6 – leisti 5 turėti savo nuotykių.',
    finances: 'Finansinis stabilumas: Vidutinis. 6 rūpinasi namų biudžetu, 5 gali per daug išleisti nuotykiams. Susitarimas dėl "laisvės fondo" gali padėti.',
    harmony: 75,
    mirror: `Ką šis žmogus tau atspindi?

Partneris Šešetas tavo gyvenime atsirado tam, kad parodytų tavo pačios santykį su įsipareigojimu, šeima ir meile, kuri reikalauja pasiaukojimo.

Veidrodžio principas:

• Rūpesčio veidrodis: Jei partnerio globa tave dusina, tai tavo pačios baimės būti „prijaukintai" atspindys. Jis moko tave, kad meilė nėra grandinės, o uostas.

• Harmonijos pamoka: Jis tau rodo tavo pačios poreikį grožiui ir ramybei, kurį tu dažnai aukoji dėl naujų įspūdžių vaikymosi.

Saugiklis jūsų harmonijai:
Tu nori išeiti, jis nori, kad liktum vakarienės. Jei jauti kaltę, tai tavo veidrodis, primenantis: „Išmok integruoti savo nuotykius į bendrą jūsų pasaulį, užuot gyvenusi du atskirus gyvenimus".`,
    // Mirror from 6's perspective (when user is 6, partner is 5)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai tavo didžiausia pamoka apie laisvę ir prisirišimą. Partneris Penketas tavo gyvenime atsirado tam, kad parodytų tavo pačios baimę būti paliktai ir poreikį „prijaukinti" tai, kas neprijaukinama.

Veidrodžio principas:

• Laisvės veidrodis: Jei partnerio nenustygimas tave gąsdina, tai tavo pačios uždusintos nuotykių ieškotojos atspindys. Jis moko tave pasitikėjimo be kontrolės.

• Pokyčių pamoka: Jis tau rodo tavo pačios prisirišimą prie iliuzinės ramybės. Tai tavo lankstumo veidrodis.

Saugiklis jūsų harmonijai:
Tu nori kurti lizdą, jis nori skristi. Jei jauti skausmą, tai tavo veidrodis, sakantis: „Nustok savintis partnerį. Tikrasis ryšys yra tada, kai abu sugrįžta namo savo noru, o ne iš pareigos".`
  },
  '5-7': {
    attraction: 'Abu vertinate nepriklausomybę ir laisvę. Suprantate vienas kito erdvės poreikį.',
    irritation: 'Gali trūkti gilaus emocinio ryšio. Abu galite vengti įsipareigojimų.',
    intimacy: 'Laisvas ir neįpareigojantis, bet gali trūkti gilumo.',
    leisure: '5 nori socialinių nuotykių, 7 – tylos ir dvasingumo. Individualios veiklos gali būti raktas.',
    family: 'Šeimos kūrimas: Netradicinė šeima, kur abu partneriai turi daug asmeninės erdvės. Vaikai mokysis nepriklausomybės. Iššūkis: emocinis ryšys.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu esate nepriklausomi finansiškai. Svarbu turėti bendrą fondą šeimos tikslams.',
    harmony: 82,
    mirror: `Ką šis žmogus tau atspindi?

Tai išorinės laisvės (5) ir vidinės laisvės (7) susitikimas. Partneris Septynetas atspindi tavo pačios poreikį gyliui ir prasmės paieškoms.

Veidrodžio principas:

• Tylos ir tiesos veidrodis: Jei partnerio atsiribojimas tave gąsdina, tai tavo pačios baimės susidurti su savo vidine tuštuma atspindys. Jis moko tave, kad didžiausi nuotykiai vyksta tavo viduje.

• Išminties pamoka: Jis tau rodo tavo pačios paviršutiniškumą. Tai tavo gebėjimo mąstyti kritiškai ir giliai veidrodis.

Saugiklis jūsų harmonijai:
Tu ieškai atsakymų pasaulyje, jis – knygose ir tyloje. Jei jauti prarają, tai tavo veidrodis, sakantis: „Sustok. Ne visi pokyčiai turi būti matomi. Leisk jam nusivesti tave į tavo sielos gelmes".`,
    // Mirror from 7's perspective (when user is 7, partner is 5)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai vidinio (7) ir išorinio (5) pasaulio piligrimų susitikimas. Partneris Penketas tavo gyvenime atsirado tam, kad išmokytų tave lankstumo ir drąsos patirti gyvenimą kūnu.

Veidrodžio principas:

• Laisvės ir patirčių veidrodis: Jei jo nenuspėjamumas tave gąsdina, tai tavo pačios baimės gyventi be plano atspindys. Jis moko tave, kad teorija be praktikos yra mirusi.

• Pokyčių pamoka: Jis tau rodo tavo pačios uždarumą. Tai tavo gebėjimo keistis kartu su gyvenimo srautu veidrodis.

Saugiklis jūsų harmonijai:
Tu nori tylos, jis – nuotykių. Jei jauti atstumą, tai tavo veidrodis, sakantis: „Nustok studijuoti gyvenimą; išeik į jį kartu su savo partneriu ir pamatysi tiesą veiksme".`
  },
  '5-8': {
    attraction: 'Abu esate ambicingi ir energingi. Dinamiškas duetas su dideliais planais.',
    irritation: '5 gali jaustis varžomas 8 kontrolės. 8 gali jaustis frustruotas dėl 5 nepastovumo.',
    intimacy: 'Aistringas ir intensyvus. Abu mėgstate valdžią, todėl gali būti įdomi dinamika.',
    leisure: 'Verslo kelionės, prabangūs restoranai, nauji iššūkiai. Abu mėgstate statusą ir nuotykius.',
    family: 'Šeimos kūrimas: Galinga šeima su didelėmis ambicijomis. Vaikai augs su drąsa ir strateginiu mąstymu. Svarbu: nepamirškite emocinio artumo.',
    finances: 'Finansinis stabilumas: Labai geras potencialas! Abu esate orientuoti į sėkmę. 8 suteikia strategiją, 5 – gebėjimą greitai prisitaikyti.',
    harmony: 88,
    mirror: `Ką šis žmogus tau atspindi?

Tai jėgos ir ekspansijos derinys. Partneris Aštuonetas atspindi tavo pačios ambiciją pasiekti didingų rezultatų ir tavo santykį su materialia galia.

Veidrodžio principas:

• Sėkmės ir kontrolės veidrodis: Jei partnerio dominavimas tave erzina, tai tavo pačios nerealizuotos jėgos atspindys. Jis moko tave savo energiją paversti konkrečia imperija.

• Teisingumo pamoka: Jis tau rodo tavo požiūrį į autoritetą. Tai tavo pačios gebėjimo valdyti savo resursus veidrodis.

Saugiklis jūsų harmonijai:
Abu esate labai stiprūs. Jei pradedate kovoti, tai tavo veidrodis, primenantis: „Jūs esate komanda. Jo strategija ir tavo greitis gali užkariauti bet kokias viršūnes".`,
    // Mirror from 8's perspective (when user is 8, partner is 5)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai ekspansijos ir laisvės derinys. Partneris Penketas tavo gyvenime atsirado tam, kad parodytų tavo pačios troškimą nuotykiams ir pokyčiams, kuriuos tu riboji dėl stabilumo.

Veidrodžio principas:

• Rizikos veidrodis: Jei jo neatsakingumas tave gąsdina, tai tavo pačios baimės prarasti kontrolę atspindys. Jis moko tave lankstumo.

• Laisvės pamoka: Jis tau rodo, kad galia yra skirta laisvei kurti, o ne kalėjimui statyti. Tai tavo gebėjimo mėgautis gyvenimu veidrodis.

Saugiklis jūsų harmonijai:
Tu nori kaupti, jis – patirti. Jei jauti konfliktą, tai tavo veidrodis, sakantis: „Investuok į patirtis, o ne tik į daiktus. Partneris moko tave gyventi čia ir dabar".`
  },
  '5-9': {
    attraction: 'Abu mylite laisvę ir plačius horizontus. Filosofiniai pokalbiai ir kelionės.',
    irritation: 'Gali trūkti praktinio įžeminimo. Abu galite "nuskristi" į sapnų pasaulį.',
    intimacy: 'Laisvas, filosofinis ir eksperimentuojantis. Abu ieškote prasmių.',
    leisure: 'Kelionės, dvasinės praktikos, filosofiniai pokalbiai. Abu mėgstate tyrinėti pasaulį ir idėjas.',
    family: 'Šeimos kūrimas: Idealistinė šeima su plačia pasaulėžiūra. Vaikai augs su tolerancija ir atvirumu. Iššūkis: praktinis įžeminimas.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti idėjoms ir kelionėms. Svarbu turėti praktišką finansų planą.',
    harmony: 92,
    mirror: `Ką šis žmogus tau atspindi?

Tai pasaulio piligrimų sąjunga. Partneris Devynetas atspindi tavo pačios idealizmą, užuojautą ir poreikį tarnauti žmonijai.

Veidrodžio principas:

• Paleidimo veidrodis: Jei partnerio atsidavimas kitiems tave erzina, tai tavo pačios egoizmo atspindys. Jis moko tave, kad laisvė yra prasminga tik tada, kai ji neša šviesą kitiems.

• Užbaigimo pamoka: Jis tau rodo tavo pačios cikliškumą. Tai tavo gebėjimo paleisti tai, kas sena, ir gimti iš naujo veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu galite pamesti realybę. Jei jauti, kad abu „skraidote", tai tavo veidrodis, sakantis: „Jūsų ryšys dvasinis, bet jūsų kūnai gyvena čia. Grįžkite į žemę, kad jūsų vizijos taptų kūnu".`,
    // Mirror from 9's perspective (when user is 9, partner is 5)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai pokyčių ir transformacijos veidrodis. Partneris Penketas tavo gyvenime atsirado tam, kad parodytų tavo pačios troškimą laisvei ir gebėjimą paleisti viską, kas nebetarnauja tavo augimui.

Veidrodžio principas:

• Laisvės veidrodis: Jei partnerio nenustygimas tave gąsdina, tai tavo pačios prisirišimo prie praeities atspindys. Jis moko tave lankstumo.

• Patirčių pamoka: Jis tau rodo, kad dvasinis gylis neatsiejamas nuo drąsos gyventi pilnavertį, fizinį gyvenimą.

Saugiklis jūsų harmonijai:
Abu galite jausti poreikį „išskristi". Jei jauti atstumą, tai tavo veidrodis, primenantis: „Tikrasis nuotykis yra jūsų abiejų transformacija. Neleiskite baimei jus išskirti".`
  },
  // Number 6 combinations
  '6-6': {
    attraction: 'Du rūpestingi ir šeimai atsidavę žmonės. Harmoninga ir šilta aplinka garantuota.',
    irritation: 'Gali būti per daug aukojimosi kitiems ir per mažai "mums". Abu galite "perdegti".',
    intimacy: 'Labai švelnus, rūpestingas ir romantiškas. Abu norite patenkinti partnerį.',
    leisure: 'Šeimos renginiai, vakarėliai namuose, sodas, kulinarija. Namų židinys yra jūsų centras.',
    family: 'Šeimos kūrimas: Ideali šeima su dviguba meilės doze! Vaikai augs mylimi ir globojami. Rizika: galite per daug aukotis vaikams ir pamiršti vienas kitą.',
    finances: 'Finansinis stabilumas: Geras. Abu esate atsakingi ir rūpinasi namų biudžetu. Svarbu investuoti į jūsų pačių santykius, ne tik į namus.',
    harmony: 82,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Šešetams, susitinka du globėjai. Šis partneris atspindi tavo pačios milžinišką poreikį rūpintis, bet kartu ir tavo polinkį į idealizmą bei nusivylimą, kai realybė neatitinka svajonių.

Veidrodžio principas:

• Tobulumo veidrodis: Jei tave erzina partnerio reikalavimai ar kritika dėl „netvarkos", tai tavo pačios vidinio nepasitenkinimo savimi atspindys.

• Aukos veidrodis: Jūs abu rodote vienas kitam, kaip lengva paskęsti kitų rūpesčiuose pamirštant save. Tai veidrodis, verčiantis paklausti: „Ar mes mylime vienas kitą, ar tik mūsų kuriamą įvaizdį?".

Saugiklis jūsų harmonijai:
Galite „uždusinti" vienas kitą rūpesčiu. Jei jauti naštą, tai tavo veidrodis, sakantis: „Leiskite vienas kitam klysti. Meilė yra tada, kai priimi netvarką abiejų širdyse".`
  },
  '6-7': {
    attraction: '6 siūlo šilumą ir rūpestį, kurio 7 viduje ieško. 7 suteikia gylį ir išmintį.',
    irritation: '7 gali atrodyti per daug uždaras 6 emociniams poreikiams. 6 gali atrodyti per daug "įsikišantis".',
    intimacy: 'Gilus ir rūpestingas, kai 7 atsipalaiduoja ir atsiveria. 6 turi būti kantrūs.',
    leisure: '6 nori šeimyninių renginių, 7 – tylos. Kompromisas: tyli veikla kartu su šeima.',
    family: 'Šeimos kūrimas: Kontrastinga, bet galima šeima. 6 sukuria šilumą, 7 – išmintį. Vaikai augs su meile ir filosofiniu požiūriu. Iššūkis: emocinis ryšys tarp partnerių.',
    finances: 'Finansinis stabilumas: Vidutinis. 6 rūpinasi namų biudžetu, 7 – analizuoja ilgalaikes investicijas. Reikia aiškaus komunikavimo apie finansus.',
    harmony: 70,
    mirror: `Ką šis žmogus tau atspindi?

Tai jausmo (6) ir mąstymo (7) susidūrimas. Partneris Septynetas atspindi tavo pačios vidinę tylą ir poreikį suprasti gilesnę gyvenimo prasmę, o ne tik rūpintis išore.

Veidrodžio principas:

• Gylio ir uždarumo veidrodis: Jei partnerio „šaltumas" tave skaudina, tai tavo pačios baimės būti neįvertintai atspindys. Jis moko tave meilės be nuolatinio patvirtinimo žodžiais.

• Išminties pamoka: Jis tau rodo tavo pačios paviršutiniškumą. Tai tavo gebėjimo ieškoti tiesos tyloje veidrodis.

Saugiklis jūsų harmonijai:
Tu nori dalintis viskuo, jis – tik tuo, kas svarbu. Jei jauti sieną, tai tavo veidrodis, sakantis: „Gerbk jo privatumą. Tavo šviesa turi šviesti, o ne deginti jo erdvę".`,
    // Mirror from 7's perspective (when user is 7, partner is 6)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Šešetas tavo gyvenime atsirado tam, kad parodytų tavo pačios poreikį meilei, globai ir žmogiškam šiltumui, kurį tu dažnai nustumi į antrą planą.

Veidrodžio principas:

• Rūpesčio ir pareigos veidrodis: Jei partnerio reikalavimai „būti kartu" tave erzina, tai tavo pačios baimės būti reikalingai atspindys. Jis moko tave, kad išmintis be meilės yra tuščia.

• Harmonijos pamoka: Jis tau rodo tavo pačios vidinį grožį, kurį tu bijai atskleisti. Tai tavo sielos jautrumo veidrodis.

Saugiklis jūsų harmonijai:
Septynetas nori tiesos, Šešetas – ramybės. Jei jauti spaudimą, tai tavo veidrodis, sakantis: „Išmok priimti švelnumą kaip dvasinę praktiką. Meilė yra aukščiausia tiesa, kurios tu ieškai".`
  },
  '6-8': {
    attraction: '6 siūlo namų šilumą, 8 – materialinį saugumą. Klasikinis "verslininko ir namų šeimininkės" derinys.',
    irritation: '8 gali per daug dirbti ir ignoruoti 6 emocinius poreikius. 6 gali jaustis "daiktų prižiūrėtoju".',
    intimacy: '8 atneša aistrą, 6 – švelnumą ir rūpestį. Geras derinys, kai 8 skiria laiko.',
    leisure: '8 nori verslo renginių, 6 – šeimos laiko. Kompromisas: prabangūs šeimos renginiai.',
    family: 'Šeimos kūrimas: Sėkminga ir pasiturinti šeima! 8 sukuria materialinį saugumą, 6 – emocinę šilumą. Vaikai augs su galimybėmis ir meile.',
    finances: 'Finansinis stabilumas: Puikus! 8 uždirba ir investuoja, 6 – protingai valdo namų biudžetą. Kartu galite sukurti turtingą gyvenimą.',
    harmony: 92,
    mirror: `Ką šis žmogus tau atspindi?

Tai viena sėkmingiausių sąjungų. Partneris Aštuonetas atspindi tavo pačios ambiciją sukurti vertingą ir gražų gyvenimą materialiame pasaulyje.

Veidrodžio principas:

• Galios ir vertės veidrodis: Jei partnerio dominavimas tave slegia, tai tavo pačios nepasitikėjimo savo jėgomis atspindys. Jis moko tave priimti turtus ir sėkmę kaip natūralią meilės dalį.

• Teisingumo pamoka: Jis tau rodo tavo pačios gebėjimą valdyti šeimos resursus. Tai tavo vidinio autoriteto veidrodis.

Saugiklis jūsų harmonijai:
Tu gali tapti jo „aptarnaujančiu personalu". Jei jauti nuoskaudą, tai tavo veidrodis, primenantis: „Tu esi imperatorė greta imperatoriaus. Tavo rūpestis turi savo kainą – gerbk save ir jis tave gerbs dar labiau".`,
    // Mirror from 8's perspective (when user is 8, partner is 6)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Šešetas tavo gyvenime atspindi tavo pačios poreikį harmonijai, šeimai ir grožiui. Jis moko tave, kad tikroji sėkmė yra tada, kai turi su kuo ja pasidalinti.

Veidrodžio principas:

• Meilės ir rūpesčio veidrodis: Jei partnerio globa tau atrodo per didelė, tai tavo pačios vidinio sausumo atspindys. Jis moko tave sušildyti savo galią meile.

• Atsakomybės už artimą pamoka: Jis tau rodo tavo pačios gebėjimą puoselėti ryšius. Tai tavo sielos jautrumo veidrodis.

Saugiklis jūsų harmonijai:
Tu gali pradėti „pirkti" meilę dovanomis. Jei jauti, kad partneris nepatenkintas, tai tavo veidrodis, primenantis: „Jam reikia tavo laiko ir buvimo, o ne tavo pasiekimų įrodymų".`
  },
  '6-9': {
    attraction: 'Abu esate rūpestingi ir altruistiški. Puikiai suprantate vienas kito tarnavimo poreikį.',
    irritation: 'Abu galite per daug aukotis kitiems ir pamiršti savo santykius.',
    intimacy: 'Labai švelnus, dvasinis ir rūpestingas. Abu ieškote prasmių meilėje.',
    leisure: 'Labdaringa veikla, šeimos renginiai, rūpinimasis kitais. Abu jaučiatės laimingi padėdami.',
    family: 'Šeimos kūrimas: Dieviška šeima su besąlygiška meile! Vaikai augs su užuojauta ir didele širdimi. Rizika: galite per daug aukotis kitiems ir pamiršti vienas kitą.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti kitiems. Svarbu nepritrūkti sau – sukurkite "šeimos fondą" pirma, o tada dalykitės su pasauliu.',
    harmony: 98,
    mirror: `Ką šis žmogus tau atspindi?

Tai dieviškos meilės ir užuojautos sąjunga. Partneris Devynetas atspindi tavo pačios sielos grožį ir gebėjimą meilę išplėsti už namų sienų.

Veidrodžio principas:

• Altruizmo veidrodis: Jei partnerio pasiaukojimas kitiems tave erzina, tai tavo pačios egoizmo atspindys. Jis moko tave, kad tavo meilė turi gydyti pasaulį.

• Atleidimo pamoka: Jis tau rodo tavo pačios sielos cikliškumą. Tai tavo gebėjimo paleisti nuoskaudas veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu galite pamiršti save rūpindamiesi kitais. Jei jauti išsekimą, tai tavo veidrodis, sakantis: „Nepamirškite, kad jūsų sąjunga yra jūsų jėgos šaltinis. Pirmiausia pamaitinkite vienas kitą, o tada – pasaulį".`,
    // Mirror from 9's perspective (when user is 9, partner is 6)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai dieviškos ir žemiškos meilės sąjunga. Partneris Šešetas atspindi tavo pačios širdies grožį ir gebėjimą sukurti rojų čia, žemėje, per rūpestį ir harmoniją.

Veidrodžio principas:

• Rūpesčio ir namų veidrodis: Jei partnerio globa tau atrodo per smulkmeniška, tai tavo pačios baimės būti „prijaukintai" atspindys. Jis moko tave, kad tavo tarnystė pasauliui prasideda nuo tavo pačios namų slenksčio.

• Idealizmo pamoka: Jis tau rodo tavo pačios poreikį grožiui ir harmonijai.

Saugiklis jūsų harmonijai:
Jūsų meilė tokia didelė, kad galite pamiršti savo ribas. Jei jauti nuoskaudą, tai tavo veidrodis, sakantis: „Mylėkite vienas kitą labiau nei savo kuriamą tobulą paveikslą".`
  },
  // Number 7 combinations
  '7-7': {
    attraction: 'Du gilūs mąstytojai kartu. Filosofiniai pokalbiai ir dvasinis ryšys.',
    irritation: 'Gali būti per daug uždarumo ir izoliacijos. Abu galite vengti emocinio artumo.',
    intimacy: 'Labai gilus ir dvasinis, kai abu atsiveria. Reikia daug laiko ir pasitikėjimo.',
    leisure: 'Skaitymas, meditacija, gamta, tyrinėjimai. Abu mėgstate tylią, prasmingą veiklą.',
    family: 'Šeimos kūrimas: Intelektuali ir dvasinė šeima. Vaikai augs su gilia pasaulėžiūra ir kritiniu mąstymu. Iššūkis: emocinis ryšys ir šiltumas.',
    finances: 'Finansinis stabilumas: Geras. Abu esate atsargūs ir analitiški. Investuojate protingai ir ilgalaikiai. Svarbu nepritrūkti spontaniškumo.',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Septynetams, susiduria du vandenynų gyliai. Šis partneris atspindi tavo pačios paslaptis, tavo dvasinį alkį, bet kartu ir tavo polinkį į visišką atsiribojimą nuo realybės.

Veidrodžio principas:

• Tylos ir paslapties veidrodis: Jei tave vargina partnerio uždarumas, tai tavo pačios baimės būti pažintai iki galo atspindys.

• Tiesos ieškojimo veidrodis: Jūs abu rodote vienas kitam, kaip sunku rasti bendrą kalbą, kai abu ieškote tobulumo. Tai veidrodis, verčiantis paklausti: „Ar mes ieškome tiesos, ar tik bėgame nuo gyvenimo?".

Saugiklis jūsų harmonijai:
Galite tapti svetimi gyvendami kartu. Jei jauti šaltį, tai tavo veidrodis, sakantis: „Išdrįskite sujungti savo tylas. Tikrasis ryšys gimsta tada, kai abiejų sielos susitinka anapus proto".`
  },
  '7-8': {
    attraction: '7 siūlo išmintį, 8 – veiksmų galią. Galimas stiprus strateginis duetas.',
    irritation: '8 gali atrodyti per daug materialistiškas. 7 gali atrodyti per daug atsiribojęs.',
    intimacy: 'Kontrastingas – 7 nori gilumo, 8 – veiksmų. Reikia komunikacijos.',
    leisure: '7 mėgsta tylą, 8 – verslo renginius. Sunkus kompromisas – individualios veiklos.',
    family: 'Šeimos kūrimas: Strategiška šeima su giliomis vertybėmis ir materialine sėkme. 7 suteikia išmintį, 8 – resursus. Iššūkis: bendras laisvalaikis.',
    finances: 'Finansinis stabilumas: Labai geras! 7 analizuoja, 8 – veikia. Kartu galite priimti puikius investicinius sprendimus.',
    harmony: 75,
    mirror: `Ką šis žmogus tau atspindi?

Tai proto (7) ir galios (8) derinys. Partneris Aštuonetas atspindi tavo pačios santykį su sėkme, įtaka ir gebėjimu valdyti materialius resursus.

Veidrodžio principas:

• Valdžios ir savivertės veidrodis: Jei partnerio dominavimas tave erzina, tai tavo pačios nepasitikėjimo savo asmenine galia atspindys.

• Teisingumo pamoka: Jis tau rodo tavo požiūrį į rezultatus. Tai tavo pačios gebėjimo pasiekti savo tikslus materialiame pasaulyje veidrodis.

Saugiklis jūsų harmonijai:
Jūsų vertybės gali skirtis – dvasia prieš pinigus. Jei jauti konfliktą, tai tavo veidrodis, primenantis: „Dvasia be materijos neturi balso, o materija be dvasios neturi prasmės. Sujunkite savo jėgas".`,
    // Mirror from 8's perspective (when user is 8, partner is 7)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai materijos ir dvasios susidūrimas. Partneris Septynetas atspindi tavo pačios vidinę tylą ir poreikį suprasti gilesnę prasmę už pinigų ir statuso.

Veidrodžio principas:

• Išminties ir tiesos veidrodis: Jei partnerio atsiribojimas tave erzina, tai tavo pačios baimės likti su savo mintimis atspindys. Jis moko tave ieškoti atsakymų savyje.

• Vertybių pamoka: Jis tau rodo tavo pačios paviršutiniškumą. Tai tavo dvasinio gylio veidrodis.

Saugiklis jūsų harmonijai:
Jūsų pasauliai gali visiškai nesusitikti. Jei jauti prarają, tai tavo veidrodis, sakantis: „Sustok bėgusi. Pasiklausyk jo įžvalgų – jos padės tavo verslui ir tavo sielai rasti ramybę".`
  },
  '7-9': {
    attraction: 'Abu esate dvasiniai ir filosofiniai. Gilus intelektualinis ir dvasinis ryšys.',
    irritation: 'Gali trūkti praktinio įžeminimo. Abu galite "pasimesti" idėjose.',
    intimacy: 'Labai gilus, transcendentinis ir dvasinis. Abu ieškote aukštesnių prasmių.',
    leisure: 'Dvasinės praktikos, filosofiniai pokalbiai, gamta, meditacija. Abu tyrinėjate gylį.',
    family: 'Šeimos kūrimas: Dvasinė ir filosofinė šeima. Vaikai augs su gilia pasaulėžiūra ir užuojauta. Iššūkis: praktinis įžeminimas.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti idėjoms ir dvasiniams tikslams. Svarbu turėti praktišką finansų planą.',
    harmony: 92,
    mirror: `Ką šis žmogus tau atspindi?

Tai mistikų ir išminčių sąjunga. Partneris Devynetas atspindi tavo pačios besąlygišką užuojautą ir poreikį tarnauti žmonijai.

Veidrodžio principas:

• Paleidimo ir transformacijos veidrodis: Jei partnerio pasiaukojimas tau atrodo „per didelis", tai tavo pačios baimės prarasti save atiduodant atspindys.

• Išminties pamoka: Jis tau rodo, kad tavo žinios (7) turi nešti naudą kitiems (9). Tai tavo sielos kilnumo veidrodis.

Saugiklis jūsų harmonijai:
Jūs abu linkę skraidyti aukštai. Jei jauti, kad abu prarandate žemę, tai tavo veidrodis, sakantis: „Sustiprinkite savo fizinį ryšį, kad jūsų bendra dvasinė misija turėtų kur nusileisti".`,
    // Mirror from 9's perspective (when user is 9, partner is 7)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Tai sielų susitikimas tyloje. Partneris Septynetas atspindi tavo pačios dvasinį gylį, tavo ieškojimus ir gebėjimą rasti atsakymus ten, kur kiti mato tik tuštumą.

Veidrodžio principas:

• Tylos ir išminties veidrodis: Jei partnerio uždarumas tave skaudina, tai tavo pačios baimės būti nereikalingai atspindys. Jis moko tave, kad sielų ryšys yra anapus žodžių.

• Analitikos pamoka: Jis tau rodo tavo pačios poreikį giliai suprasti visatos dėsnius.

Saugiklis jūsų harmonijai:
Galite tapti per daug atitrūkę nuo realybės. Jei jauti šaltį, tai tavo veidrodis, sakantis: „Sujunkite savo tylas bendra kūryba ar veikla, kad jūsų gylis netaptų praraja".`
  },
  // Number 8 combinations
  '8-8': {
    attraction: 'Du galingi ir ambicingi žmonės kartu! Potencialas milžiniškai sėkmei.',
    irritation: 'Valdžios kovos – abu norite vadovauti. Gali būti konkurencija vietoj bendradarbiavimo.',
    intimacy: 'Intensyvus ir valdantis. Abu mėgstate kontrolę, todėl reikia derybų.',
    leisure: 'Verslo renginiai, prabanga, kelionės pirmąja klase. Abu vertinate statusą.',
    family: 'Šeimos kūrimas: Galinga, ambicinga šeima su didžiuliais resursais. Vaikai augs su didelėmis galimybėmis. Iššūkis: emocinis artumas ir valdžios pasidalijimas.',
    finances: 'Finansinis stabilumas: Puikus potencialas! Abu orientuoti į materialinę sėkmę. Rizika: konkurencija vietoj bendradarbiavimo. Raktas: aiškūs susitarimai dėl sprendimų.',
    harmony: 70,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Aštuonetams, susitinka du titonai. Partneris atspindi tavo pačios milžinišką jėgą, bet kartu ir tavo polinkį į negailestingumą bei egoizmą.

Veidrodžio principas:

• Veidrodinis dominavimas: Jei tave siutina partnerio noras kontroliuoti, tai tavo pačios „tironiškos" pusės atspindys.

• Karmos veidrodis: Jūs abu rodote vienas kitam, kaip veikia priežasties ir pasekmės dėsnis. Tai veidrodis, verčiantis paklausti: „Ką mes kuriame – bendrą imperiją ar du atskirus kalėjimus?".

Saugiklis jūsų harmonijai:
Jūsų konkurencija gali sunaikinti santykius. Jei kovojate, tai tavo veidrodis, sakantis: „Nusižemink. Tikra partnerystė prasideda tada, kai pripažįsti kito jėgą kaip savo papildymą, o ne grėsmę".`
  },
  '8-9': {
    attraction: '8 siūlo materialinę galią, 9 – prasmę ir viziją. Galimas galingas transformuojantis duetas.',
    irritation: '9 gali atrodyti per daug idealistiškas. 8 gali atrodyti per daug materialistiškas.',
    intimacy: '8 atneša aistrą, 9 – dvasinį gylį. Geras derinys, kai abu randa balansą.',
    leisure: 'Labdaringi verslo projektai, filantropija, vizijų įgyvendinimas. Abu nori keisti pasaulį.',
    family: 'Šeimos kūrimas: Galinga ir prasminga šeima. 8 sukuria materialinį saugumą, 9 – dvasines vertybes. Vaikai augs su galimybėmis ir užuojauta.',
    finances: 'Finansinis stabilumas: Geras. 8 uždirba, 9 – nurodo, kaip panaudoti prasmingai. Kartu galite daryti didelį poveikį.',
    harmony: 90,
    mirror: `Ką šis žmogus tau atspindi?

Partneris Devynetas tavo gyvenime atsirado tam, kad parodytų tavo pačios gebėjimą tarnauti pasauliui ir paleisti prisirišimą prie materialių gėrybių.

Veidrodžio principas:

• Altruizmo veidrodis: Jei jo noras „atiduoti viską kitiems" tave erzina, tai tavo pačios godumo ar nesaugumo atspindys. Jis moko tave meilės be lūkesčių.

• Transformacijos pamoka: Jis tau rodo tavo pačios sielos brandą. Tai tavo gebėjimo palikti pėdsaką žmonių širdyse veidrodis.

Saugiklis jūsų harmonijai:
Tu nori valdyti pasaulį, jis – jį išgelbėti. Jei jauti konfliktą, tai tavo veidrodis, sakantis: „Tavo resursai ir jo vizija gali padaryti stebuklus. Naudok savo galią gėriui".`,
    // Mirror from 9's perspective (when user is 9, partner is 8)
    mirrorReverse: `Ką šis žmogus tau atspindi?

Partneris Aštuonetas tavo gyvenime atsirado tam, kad parodytų tavo pačios asmeninį autoritetą ir gebėjimą valdyti jėgą teisingai. Jis yra tavo materialios realizacijos veidrodis.

Veidrodžio principas:

• Galios ir teisingumo veidrodis: Jei partnerio dominavimas tave erzina, tai tavo pačios baimes naudotis savo jėga atspindys. Jis moko tave, kad tavo vizija turi turėti jėgą (8), kad išliktų.

• Karmos pamoka: Jis tau rodo tavo požiūrį į rezultatus ir atlygį.

Saugiklis jūsų harmonijai:
Tu nori atiduoti, jis – uždirbti. Jei jauti konfliktą, tai tavo veidrodis, primenantis: „Jūsų ryšys yra galingas įrankis keisti pasaulį. Naudokite jo resursus savo šviesiai misijai".`
  },
  // Number 9 combinations
  '9-9': {
    attraction: 'Du humanistai kartu! Gilus dvasinis ryšys ir bendra vizija geresniam pasauliui.',
    irritation: 'Gali būti per daug idealizmo ir per mažai praktikos. Abu galite "perdegti" aukodamiesi.',
    intimacy: 'Labai gilus, dvasinis ir transcendentinis. Abu ieškote universalios meilės.',
    leisure: 'Labdaringa veikla, dvasinės praktikos, menas. Abu norite padaryti pasaulį geresnį.',
    family: 'Šeimos kūrimas: Dvasinė ir idealistinė šeima. Vaikai augs su didele užuojauta ir pasaulėžiūra. Iššūkis: praktinis įžeminimas ir ribų nustatymas.',
    finances: 'Finansinis stabilumas: Vidutinis. Abu linkę aukoti kitiems. Svarbu nepritrūkti sau – sukurkite „pagrindą" pirma, o tada dalykitės.',
    harmony: 85,
    mirror: `Ką šis žmogus tau atspindi?

Susitikus dviem Devynetams, susitinka du sielos meistrai. Šis partneris atspindi tavo pačios besąlygišką užuojautą, bet kartu ir tavo polinkį į kankinystę bei nesugebėjimą paleisti praeities naštų.

Veidrodžio principas:

• Paleidimo veidrodis: Jei tave vargina partnerio idealizmas ar aukojimasis, tai tavo pačios nesugebėjimo pasakyti „ne" sau ir kitiems atspindys.

• Užbaigimo veidrodis: Jūs abu rodote vienas kitam, kaip svarbu užbaigti senuosius ciklus su padėka. Verčia paklausti: „Ar mes pasiruošę skristi toliau, ar tik abu laikomės už senų griuvėsių?".

Saugiklis jūsų harmonijai:
Jūsų ryšys toks stiprus, kad galite pamesti save vienas kitame. Jei jauti sielos išsekimą, tai tavo veidrodis, sakantis: „Išmokite atsigręžti į save. Pirmiausia išgelbėkite savo širdį, o tada – visą likusį pasaulį".`
  }
};

// Get detailed compatibility information
// userLifePath = VARTOTOJO gyvenimo kelio skaičius (tas, kuris naudoja programą)
// partnerLifePath = PARTNERIO gyvenimo kelio skaičius
export function getDetailedCompatibility(userLifePath, partnerLifePath) {
  // Reduce master numbers to single digits for lookup
  const reduceNumber = (num) => {
    if (num === 11 || num === 22 || num === 33 || num === 44) {
      return num.toString().split('').reduce((a, b) => parseInt(a) + parseInt(b), 0);
    }
    return num;
  };
  
  const userNum = reduceNumber(userLifePath);
  const partnerNum = reduceNumber(partnerLifePath);
  
  // Create key (always smaller number first for lookup)
  const key = userNum <= partnerNum ? `${userNum}-${partnerNum}` : `${partnerNum}-${userNum}`;
  
  // Determine if we need to use reverse mirror (when user has larger number)
  const needsReverseMirror = userNum > partnerNum;
  
  const details = COMPATIBILITY_DETAILS[key];
  
  if (!details) {
    return {
      attraction: 'Jūsų energijos yra unikalios ir sukuria įdomią dinamiką. Kas jus traukia – partnerio savybės, kurios papildo jūsų prigimtį.',
      irritation: 'Kaip ir bet kuriuose santykiuose, skirtumai gali kelti iššūkių. Svarbiausia – atvira komunikacija ir abipusė pagarba.',
      intimacy: 'Jūsų intymumas yra unikalus ir gali būti labai gilus, kai abu partneriai yra atviri ir pasitikintys vienas kitu.',
      leisure: 'Ieškokite veiklų, kurios džiugina abu. Kompromisas ir noras tyrinėti naują yra raktas į sėkmingą laisvalaikį kartu.'
    };
  }
  
  // Return details with correct mirror perspective
  // If user has larger number, use mirrorReverse if available
  const result = { ...details };
  
  if (needsReverseMirror && details.mirrorReverse) {
    result.mirror = details.mirrorReverse;
  }
  
  // Add metadata about the perspective for display
  result.userNumber = userNum;
  result.partnerNumber = partnerNum;
  
  return result;
}

// =============================================================================
// CATEGORY-SPECIFIC DESCRIPTIONS
// =============================================================================
// These are separate descriptions for each numerology category:
// - LIFE_PATH: Mission, life purpose, destiny
// - SOUL_URGE: Inner desires, what the soul craves
// - EXPRESSION: How you express yourself, talents
// - PERSONALITY: How others perceive you, outer self

// For now, using placeholder text (same as character) - replace with unique content later
export const LIFE_PATH_DESCRIPTIONS = {
  1: {
    title: 'Lyderis ir Pradžia',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 1]
    
Jūsų gyvenimo misija – būti lyderiu ir pradininku. Esate čia, kad vestumėte kitus naujais keliais ir drąsiai imtumėtės iniciatyvos ten, kur kiti dvejoja.

${NUMBER_DESCRIPTIONS[1].character}`,
    advice: NUMBER_DESCRIPTIONS[1].advice
  },
  2: {
    title: 'Tarpininkas ir Diplomatas',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 2]
    
Jūsų gyvenimo misija – kurti harmoniją ir būti tiltu tarp žmonių. Esate čia, kad padėtumėte kitiems rasti bendrą kalbą ir sukurtumėte taikų bendradarbiavimą.

${NUMBER_DESCRIPTIONS[2].character}`,
    advice: NUMBER_DESCRIPTIONS[2].advice
  },
  3: {
    title: 'Kūrėjas ir Komunikatorius',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 3]
    
Jūsų gyvenimo misija – kurti ir dalytis grožiu su pasauliu. Esate čia, kad įkvėptumėte kitus savo kūrybiškumu ir komunikacijos dovana.

${NUMBER_DESCRIPTIONS[3].character}`,
    advice: NUMBER_DESCRIPTIONS[3].advice
  },
  4: {
    title: 'Statytojas ir Stabilumas',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 4]
    
Jūsų gyvenimo misija – kurti tvirtus pamatus ir struktūras. Esate čia, kad sukurtumėte ilgalaikę vertę per sistemingą ir atsidavusį darbą.

${NUMBER_DESCRIPTIONS[4].character}`,
    advice: NUMBER_DESCRIPTIONS[4].advice
  },
  5: {
    title: 'Laisvė ir Nuotykiai',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 5]
    
Jūsų gyvenimo misija – tyrinėti ir keistis. Esate čia, kad vestumėte kitus per transformacijas ir parodytumėte laisvės vertę.

${NUMBER_DESCRIPTIONS[5].character}`,
    advice: NUMBER_DESCRIPTIONS[5].advice
  },
  6: {
    title: 'Globėjas ir Harmonija',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 6]
    
Jūsų gyvenimo misija – globoti ir kurti harmoniją. Esate čia, kad sukurtumėte meilės ir rūpesčio erdvę kitiems.

${NUMBER_DESCRIPTIONS[6].character}`,
    advice: NUMBER_DESCRIPTIONS[6].advice
  },
  7: {
    title: 'Ieškotojas ir Išminčius',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 7]
    
Jūsų gyvenimo misija – ieškoti tiesos ir dalytis išmintimi. Esate čia, kad atrastumėte gilesnes prasmes ir vestumėte kitus dvasiniu keliu.

${NUMBER_DESCRIPTIONS[7].character}`,
    advice: NUMBER_DESCRIPTIONS[7].advice
  },
  8: {
    title: 'Valdovas ir Galybė',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 8]
    
Jūsų gyvenimo misija – valdyti ir kurti materialinę gerovę. Esate čia, kad parodytumėte, kaip galią galima naudoti gėriui.

${NUMBER_DESCRIPTIONS[8].character}`,
    advice: NUMBER_DESCRIPTIONS[8].advice
  },
  9: {
    title: 'Humanistas ir Užbaigimas',
    description: `[GYVENIMO KELIO APRAŠYMAS - SKAIČIUS 9]
    
Jūsų gyvenimo misija – tarnauti žmonijai ir skleisti universalią meilę. Esate čia, kad pakeltumėte pasaulį į aukštesnį sąmonės lygį.

${NUMBER_DESCRIPTIONS[9].character}`,
    advice: NUMBER_DESCRIPTIONS[9].advice
  },
  11: {
    title: 'Šviesos Nešėjas',
    description: `[GYVENIMO KELIO APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Jūsų gyvenimo misija – nešti šviesą ir įkvėpimą. Esate čia, kad būtumėte tiltu tarp dvasinio ir materialaus pasaulio.

${NUMBER_DESCRIPTIONS[11].character}`,
    advice: NUMBER_DESCRIPTIONS[11].advice
  },
  22: {
    title: 'Meistras Statytojas',
    description: `[GYVENIMO KELIO APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Jūsų gyvenimo misija – kurti monumentalius dalykus, kurie tarnaus kartoms. Esate čia, kad paverstumėte didžiules vizijas realybe.

${NUMBER_DESCRIPTIONS[22].character}`,
    advice: NUMBER_DESCRIPTIONS[22].advice
  },
  33: {
    title: 'Mokytojo Mokytojas',
    description: `[GYVENIMO KELIO APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Jūsų gyvenimo misija – mokyti besąlyginės meilės per pavyzdį. Esate čia, kad pakeltumėte žmonijos sąmonę.

${NUMBER_DESCRIPTIONS[33].character}`,
    advice: NUMBER_DESCRIPTIONS[33].advice
  }
};

export const SOUL_URGE_DESCRIPTIONS = {
  1: {
    title: 'Nepriklausomybės Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 1]
    
Jūsų siela trokšta nepriklausomybės ir lyderystės. Giliai viduje jaučiate poreikį būti pirmuoju, vesti kitus ir kurti savo kelią.

${NUMBER_DESCRIPTIONS[1].character}`,
    advice: NUMBER_DESCRIPTIONS[1].advice
  },
  2: {
    title: 'Harmonijos Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 2]
    
Jūsų siela trokšta harmonijos ir partnerystės. Giliai viduje jaučiate poreikį kurti taikius santykius ir būti suprastas.

${NUMBER_DESCRIPTIONS[2].character}`,
    advice: NUMBER_DESCRIPTIONS[2].advice
  },
  3: {
    title: 'Saviraiškos Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 3]
    
Jūsų siela trokšta kūrybinės saviraiškos ir džiaugsmo. Giliai viduje jaučiate poreikį dalytis grožiu ir įkvėpti kitus.

${NUMBER_DESCRIPTIONS[3].character}`,
    advice: NUMBER_DESCRIPTIONS[3].advice
  },
  4: {
    title: 'Stabilumo Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 4]
    
Jūsų siela trokšta stabilumo ir tvarkos. Giliai viduje jaučiate poreikį kurti tvirtus pamatus ir saugumo jausmą.

${NUMBER_DESCRIPTIONS[4].character}`,
    advice: NUMBER_DESCRIPTIONS[4].advice
  },
  5: {
    title: 'Laisvės Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 5]
    
Jūsų siela trokšta laisvės ir nuotykių. Giliai viduje jaučiate poreikį tyrinėti, keistis ir patirti viską, ką gyvenimas siūlo.

${NUMBER_DESCRIPTIONS[5].character}`,
    advice: NUMBER_DESCRIPTIONS[5].advice
  },
  6: {
    title: 'Meilės Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 6]
    
Jūsų siela trokšta meilės ir rūpesčio. Giliai viduje jaučiate poreikį globoti, kurti šeimą ir harmoniją.

${NUMBER_DESCRIPTIONS[6].character}`,
    advice: NUMBER_DESCRIPTIONS[6].advice
  },
  7: {
    title: 'Išminties Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 7]
    
Jūsų siela trokšta išminties ir tiesos. Giliai viduje jaučiate poreikį suprasti gilumines gyvenimo prasmes.

${NUMBER_DESCRIPTIONS[7].character}`,
    advice: NUMBER_DESCRIPTIONS[7].advice
  },
  8: {
    title: 'Galios Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 8]
    
Jūsų siela trokšta galios ir pasiekimų. Giliai viduje jaučiate poreikį kurti turtą ir daryti įtaką pasauliui.

${NUMBER_DESCRIPTIONS[8].character}`,
    advice: NUMBER_DESCRIPTIONS[8].advice
  },
  9: {
    title: 'Tarnavimo Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - SKAIČIUS 9]
    
Jūsų siela trokšta tarnauti ir mylėti be sąlygų. Giliai viduje jaučiate poreikį padėti žmonijai ir palikti geresnį pasaulį.

${NUMBER_DESCRIPTIONS[9].character}`,
    advice: NUMBER_DESCRIPTIONS[9].advice
  },
  11: {
    title: 'Dvasinio Švietimo Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Jūsų siela trokšta dvasinio švietimo ir intuicijos. Giliai viduje jaučiate ryšį su aukštesniais matmenimis.

${NUMBER_DESCRIPTIONS[11].character}`,
    advice: NUMBER_DESCRIPTIONS[11].advice
  },
  22: {
    title: 'Didžiųjų Darbų Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Jūsų siela trokšta kurti didžiulius, reikšmingus dalykus. Giliai viduje jaučiate poreikį palikti monumentalų palikimą.

${NUMBER_DESCRIPTIONS[22].character}`,
    advice: NUMBER_DESCRIPTIONS[22].advice
  },
  33: {
    title: 'Besąlygiškos Meilės Troškimas',
    description: `[SIELOS TROŠKIMO APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Jūsų siela trokšta besąlyginės meilės ir mokymo. Giliai viduje jaučiate poreikį gydyti ir kelti kitus.

${NUMBER_DESCRIPTIONS[33].character}`,
    advice: NUMBER_DESCRIPTIONS[33].advice
  }
};

export const EXPRESSION_DESCRIPTIONS = {
  1: {
    title: 'Lyderio Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 1]
    
Jūsų talentai ir gebėjimai reiškiasi per lyderystę ir iniciatyvą. Natūraliai išsiskiriate kaip pradininkas ir novatorius.

${NUMBER_DESCRIPTIONS[1].character}`,
    advice: NUMBER_DESCRIPTIONS[1].advice
  },
  2: {
    title: 'Diplomato Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 2]
    
Jūsų talentai reiškiasi per diplomatiją ir bendradarbiavimą. Natūraliai kuriate harmoniją ir tiltus tarp žmonių.

${NUMBER_DESCRIPTIONS[2].character}`,
    advice: NUMBER_DESCRIPTIONS[2].advice
  },
  3: {
    title: 'Kūrėjo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 3]
    
Jūsų talentai reiškiasi per kūrybiškumą ir komunikaciją. Natūraliai įkvepiate kitus savo menu ir žodžiais.

${NUMBER_DESCRIPTIONS[3].character}`,
    advice: NUMBER_DESCRIPTIONS[3].advice
  },
  4: {
    title: 'Statytojo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 4]
    
Jūsų talentai reiškiasi per sistemingumą ir praktinį požiūrį. Natūraliai kuriate tvarias struktūras ir sistemas.

${NUMBER_DESCRIPTIONS[4].character}`,
    advice: NUMBER_DESCRIPTIONS[4].advice
  },
  5: {
    title: 'Tyrinėtojo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 5]
    
Jūsų talentai reiškiasi per prisitaikymą ir įvairovę. Natūraliai sugebate prisitaikyti prie bet kokių aplinkybių.

${NUMBER_DESCRIPTIONS[5].character}`,
    advice: NUMBER_DESCRIPTIONS[5].advice
  },
  6: {
    title: 'Globėjo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 6]
    
Jūsų talentai reiškiasi per rūpestį ir harmoniją. Natūraliai kuriate jaukią, meilės kupiną aplinką.

${NUMBER_DESCRIPTIONS[6].character}`,
    advice: NUMBER_DESCRIPTIONS[6].advice
  },
  7: {
    title: 'Išminčiaus Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 7]
    
Jūsų talentai reiškiasi per analizę ir intuiciją. Natūraliai matote tai, ko kiti nepastebi.

${NUMBER_DESCRIPTIONS[7].character}`,
    advice: NUMBER_DESCRIPTIONS[7].advice
  },
  8: {
    title: 'Valdovo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 8]
    
Jūsų talentai reiškiasi per vadovavimą ir strateginį mąstymą. Natūraliai kuriate sėkmę ir gerovę.

${NUMBER_DESCRIPTIONS[8].character}`,
    advice: NUMBER_DESCRIPTIONS[8].advice
  },
  9: {
    title: 'Humanisto Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - SKAIČIUS 9]
    
Jūsų talentai reiškiasi per užuojautą ir universalią meilę. Natūraliai padedete kitiems ir keliate sąmonę.

${NUMBER_DESCRIPTIONS[9].character}`,
    advice: NUMBER_DESCRIPTIONS[9].advice
  },
  11: {
    title: 'Intuityvo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Jūsų talentai reiškiasi per intuiciją ir dvasinį švietimą. Natūraliai įkvepiate ir vedates kitus.

${NUMBER_DESCRIPTIONS[11].character}`,
    advice: NUMBER_DESCRIPTIONS[11].advice
  },
  22: {
    title: 'Meistro Statytojo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Jūsų talentai reiškiasi per monumentalių vizijų realizavimą. Natūraliai kuriate ilgalaikę vertę.

${NUMBER_DESCRIPTIONS[22].character}`,
    advice: NUMBER_DESCRIPTIONS[22].advice
  },
  33: {
    title: 'Mokytojo Išraiška',
    description: `[IŠRAIŠKOS APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Jūsų talentai reiškiasi per mokymą ir besąlygišką meilę. Natūraliai gydate ir keliate kitus.

${NUMBER_DESCRIPTIONS[33].character}`,
    advice: NUMBER_DESCRIPTIONS[33].advice
  }
};

export const PERSONALITY_DESCRIPTIONS = {
  1: {
    title: 'Lyderio Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 1]
    
Kiti mato jus kaip stiprų, nepriklausomą lyderį. Jūsų išvaizda spinduliuoja pasitikėjimą ir autoritetą.

${NUMBER_DESCRIPTIONS[1].character}`,
    advice: NUMBER_DESCRIPTIONS[1].advice
  },
  2: {
    title: 'Diplomato Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 2]
    
Kiti mato jus kaip taikų, draugišką žmogų. Jūsų išvaizda spinduliuoja švelnumą ir prieinamumą.

${NUMBER_DESCRIPTIONS[2].character}`,
    advice: NUMBER_DESCRIPTIONS[2].advice
  },
  3: {
    title: 'Kūrėjo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 3]
    
Kiti mato jus kaip linksmą, kūrybišką asmenybę. Jūsų išvaizda spinduliuoja optimizmą ir žavesį.

${NUMBER_DESCRIPTIONS[3].character}`,
    advice: NUMBER_DESCRIPTIONS[3].advice
  },
  4: {
    title: 'Statytojo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 4]
    
Kiti mato jus kaip patikimą, stabilų žmogų. Jūsų išvaizda spinduliuoja rimtumą ir sąžiningumą.

${NUMBER_DESCRIPTIONS[4].character}`,
    advice: NUMBER_DESCRIPTIONS[4].advice
  },
  5: {
    title: 'Nuotykių Ieškotojo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 5]
    
Kiti mato jus kaip dinamišką, laisvą dvasią. Jūsų išvaizda spinduliuoja energiją ir nuotykių dvasią.

${NUMBER_DESCRIPTIONS[5].character}`,
    advice: NUMBER_DESCRIPTIONS[5].advice
  },
  6: {
    title: 'Globėjo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 6]
    
Kiti mato jus kaip šiltą, rūpestingą žmogų. Jūsų išvaizda spinduliuoja meilę ir harmoniją.

${NUMBER_DESCRIPTIONS[6].character}`,
    advice: NUMBER_DESCRIPTIONS[6].advice
  },
  7: {
    title: 'Išminčiaus Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 7]
    
Kiti mato jus kaip paslaptingą, gilų mąstytoją. Jūsų išvaizda spinduliuoja išmintį ir misticiškumą.

${NUMBER_DESCRIPTIONS[7].character}`,
    advice: NUMBER_DESCRIPTIONS[7].advice
  },
  8: {
    title: 'Valdovo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 8]
    
Kiti mato jus kaip galingą, sėkmingą asmenybę. Jūsų išvaizda spinduliuoja autoritetą ir ambicijas.

${NUMBER_DESCRIPTIONS[8].character}`,
    advice: NUMBER_DESCRIPTIONS[8].advice
  },
  9: {
    title: 'Humanisto Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - SKAIČIUS 9]
    
Kiti mato jus kaip idealistas, užjaučiantį žmogų. Jūsų išvaizda spinduliuoja universalią meilę.

${NUMBER_DESCRIPTIONS[9].character}`,
    advice: NUMBER_DESCRIPTIONS[9].advice
  },
  11: {
    title: 'Intuityvo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Kiti mato jus kaip įkvepiantį, intuityvų žmogų. Jūsų išvaizda spinduliuoja dvasinę šviesą.

${NUMBER_DESCRIPTIONS[11].character}`,
    advice: NUMBER_DESCRIPTIONS[11].advice
  },
  22: {
    title: 'Meistro Statytojo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Kiti mato jus kaip galingą vizionierių. Jūsų išvaizda spinduliuoja didžiulę galią ir potencialą.

${NUMBER_DESCRIPTIONS[22].character}`,
    advice: NUMBER_DESCRIPTIONS[22].advice
  },
  33: {
    title: 'Mokytojo Asmenybė',
    description: `[ASMENYBĖS APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Kiti mato jus kaip išmintingą mokytoją ir gydytoją. Jūsų išvaizda spinduliuoja besąlygišką meilę.

${NUMBER_DESCRIPTIONS[33].character}`,
    advice: NUMBER_DESCRIPTIONS[33].advice
  }
};

// Helper function to get category-specific description
export const getCategoryDescription = (category, number) => {
  const num = parseInt(number);
  switch(category) {
    case 'lifePath':
      return LIFE_PATH_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    case 'soulUrge':
      return SOUL_URGE_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    case 'expression':
      return EXPRESSION_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    case 'personality':
      return PERSONALITY_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    case 'birthDay':
      return BIRTH_DAY_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    case 'destiny':
      return DESTINY_NUMBER_DESCRIPTIONS[num] || NUMBER_DESCRIPTIONS[num];
    default:
      return NUMBER_DESCRIPTIONS[num];
  }
};

// =============================================================================
// BIRTH DAY DESCRIPTIONS - Character/Talents based on birth day
// =============================================================================
export const BIRTH_DAY_DESCRIPTIONS = {
  1: {
    title: 'Gimimo diena 1 – Lyderis',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 1]
    
Gimę 1-ą dieną, jūs esate natūralus lyderis su stipria valia ir nepriklausomybe. Jūsų talentai slypi iniciatyvoje ir gebėjime pradėti naujus projektus.

${NUMBER_DESCRIPTIONS[1].character}`,
    talents: 'Lyderystė, originalumas, drąsa, iniciatyva'
  },
  2: {
    title: 'Gimimo diena 2 – Diplomatas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 2]
    
Gimę 2-ą dieną, jūs esate jautrus ir diplomatiškas. Jūsų talentai slypi bendradarbiavime ir gebėjime kurti harmoniją tarp žmonių.

${NUMBER_DESCRIPTIONS[2].character}`,
    talents: 'Diplomatija, empatija, partnerystė, intuicija'
  },
  3: {
    title: 'Gimimo diena 3 – Kūrėjas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 3]
    
Gimę 3-ią dieną, jūs esate kūrybingas ir komunikabilus. Jūsų talentai slypi meninėje išraiškoje ir gebėjime įkvėpti kitus.

${NUMBER_DESCRIPTIONS[3].character}`,
    talents: 'Kūrybiškumas, komunikacija, optimizmas, meniškumas'
  },
  4: {
    title: 'Gimimo diena 4 – Statytojas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 4]
    
Gimę 4-ą dieną, jūs esate praktiškas ir patikimas. Jūsų talentai slypi organizavime ir gebėjime kurti tvirtus pamatus.

${NUMBER_DESCRIPTIONS[4].character}`,
    talents: 'Sistemingumas, patikimumas, kantrybė, praktiniai įgūdžiai'
  },
  5: {
    title: 'Gimimo diena 5 – Nuotykių ieškotojas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 5]
    
Gimę 5-ą dieną, jūs esate dinamiškas ir laisvę mylintis. Jūsų talentai slypi prisitaikyme ir gebėjime komunikuoti su įvairiais žmonėmis.

${NUMBER_DESCRIPTIONS[5].character}`,
    talents: 'Prisitaikymas, komunikacija, laisvės dvasia, įvairovė'
  },
  6: {
    title: 'Gimimo diena 6 – Globėjas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 6]
    
Gimę 6-ą dieną, jūs esate rūpestingas ir harmonijos siekiantis. Jūsų talentai slypi šeimos ir bendruomenės kūrime.

${NUMBER_DESCRIPTIONS[6].character}`,
    talents: 'Rūpestis, atsakomybė, meilė, harmonijos kūrimas'
  },
  7: {
    title: 'Gimimo diena 7 – Mąstytojas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 7]
    
Gimę 7-ą dieną, jūs esate analitiškas ir intuityvus. Jūsų talentai slypi tyrinėjime ir gilių tiesų ieškojime.

${NUMBER_DESCRIPTIONS[7].character}`,
    talents: 'Analizė, intuicija, dvasingumas, tyrinėjimas'
  },
  8: {
    title: 'Gimimo diena 8 – Valdovas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 8]
    
Gimę 8-ą dieną, jūs esate ambicingas ir orientuotas į sėkmę. Jūsų talentai slypi versle ir gebėjime valdyti materialius išteklius.

${NUMBER_DESCRIPTIONS[8].character}`,
    talents: 'Vadovavimas, verslas, finansinė išmintis, ambicija'
  },
  9: {
    title: 'Gimimo diena 9 – Humanistas',
    description: `[GIMIMO DIENOS APRAŠYMAS - SKAIČIUS 9]
    
Gimę 9-ą dieną, jūs esate užjaučiantis ir idealistas. Jūsų talentai slypi tarnavime kitiems ir gebėjime matyti platesnį vaizdą.

${NUMBER_DESCRIPTIONS[9].character}`,
    talents: 'Užuojauta, idealizmas, meniškumas, globalus mąstymas'
  },
  11: {
    title: 'Gimimo diena 11 – Šviesos nešėjas (Meistro skaičius)',
    description: `[GIMIMO DIENOS APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Gimę 11-ą dieną, jūs turite ypatingą dvasinę dovaną. Tai meistro skaičius, suteikiantis stiprią intuiciją ir gebėjimą įkvėpti kitus.

${NUMBER_DESCRIPTIONS[11].character}`,
    talents: 'Intuicija, įkvėpimas, dvasinis švietimas, vizionierius'
  },
  22: {
    title: 'Gimimo diena 22 – Meistras statytojas (Meistro skaičius)',
    description: `[GIMIMO DIENOS APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Gimę 22-ą dieną, jūs turite galią kurti didžiulius dalykus. Tai meistro skaičius, leidžiantis paversti vizijas realybe.

${NUMBER_DESCRIPTIONS[22].character}`,
    talents: 'Monumentalių projektų kūrimas, praktinė vizija, globalus poveikis'
  },
  33: {
    title: 'Gimimo diena 33 – Mokytojas (Meistro skaičius)',
    description: `[GIMIMO DIENOS APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Gimę 33-ią dieną (nėra tokios datos, bet jei skaičius redukuojasi į 33), jūs turite mokytojo dovaną ir gebėjimą gydyti kitus meile.

${NUMBER_DESCRIPTIONS[33].character}`,
    talents: 'Mokymas, besąlygiška meilė, gydymas, dvasinis vadovavimas'
  },
  44: {
    title: 'Gimimo diena 44 – Meistras manifestuotojas (Meistro skaičius)',
    description: `[GIMIMO DIENOS APRAŠYMAS - MEISTRO SKAIČIUS 44]
    
44 yra ypatingai galingas meistro skaičius, suteikiantis gebėjimą materializuoti didžiausias vizijas per sistemingą darbą.

${NUMBER_DESCRIPTIONS[44]?.character || NUMBER_DESCRIPTIONS[8].character}`,
    talents: 'Materialinė manifestacija, sisteminis požiūris, didžiulė ištvermė'
  }
};

// =============================================================================
// DESTINY NUMBER DESCRIPTIONS - Based on Month + Day
// =============================================================================
export const DESTINY_NUMBER_DESCRIPTIONS = {
  1: {
    title: 'Likimo skaičius 1 – Pradžios kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 1]
    
Jūsų likimas yra būti pradininku ir lyderiu. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad vestumėte kitus naujais keliais.

${NUMBER_DESCRIPTIONS[1].character}`,
    destiny: 'Lyderystė, inovacijos, savarankiškumas'
  },
  2: {
    title: 'Likimo skaičius 2 – Partnerystės kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 2]
    
Jūsų likimas yra kurti partnerystes ir harmoniją. Mėnesio ir dienos kombinacija rodo jūsų gebėjimą jungti žmones.

${NUMBER_DESCRIPTIONS[2].character}`,
    destiny: 'Bendradarbiavimas, diplomatija, pusiausvyra'
  },
  3: {
    title: 'Likimo skaičius 3 – Kūrybos kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 3]
    
Jūsų likimas yra kurti ir įkvėpti. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad neštumėte džiaugsmą ir grožį.

${NUMBER_DESCRIPTIONS[3].character}`,
    destiny: 'Kūryba, komunikacija, džiaugsmo skleidimas'
  },
  4: {
    title: 'Likimo skaičius 4 – Stabilumo kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 4]
    
Jūsų likimas yra kurti tvirtus pamatus. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad sukurtumėte ilgalaikę vertę.

${NUMBER_DESCRIPTIONS[4].character}`,
    destiny: 'Struktūra, stabilumas, ilgalaikis darbas'
  },
  5: {
    title: 'Likimo skaičius 5 – Laisvės kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 5]
    
Jūsų likimas yra patirti laisvę ir pokyčius. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad tyrinėtumėte ir keistumėtės.

${NUMBER_DESCRIPTIONS[5].character}`,
    destiny: 'Laisvė, nuotykiai, transformacija'
  },
  6: {
    title: 'Likimo skaičius 6 – Meilės kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 6]
    
Jūsų likimas yra mylėti ir globoti. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad sukurtumėte harmoningą šeimą ir bendruomenę.

${NUMBER_DESCRIPTIONS[6].character}`,
    destiny: 'Meilė, šeima, harmonija, rūpestis'
  },
  7: {
    title: 'Likimo skaičius 7 – Išminties kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 7]
    
Jūsų likimas yra ieškoti tiesos ir išminties. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad atrastumėte gilesnes prasmes.

${NUMBER_DESCRIPTIONS[7].character}`,
    destiny: 'Dvasingumas, tyrinėjimas, gilios žinios'
  },
  8: {
    title: 'Likimo skaičius 8 – Galios kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 8]
    
Jūsų likimas yra valdyti ir kurti gerovę. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad pasiektumėte materialinės sėkmės.

${NUMBER_DESCRIPTIONS[8].character}`,
    destiny: 'Galia, turtas, pasiekimai, autoritetas'
  },
  9: {
    title: 'Likimo skaičius 9 – Tarnavimo kelias',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - SKAIČIUS 9]
    
Jūsų likimas yra tarnauti žmonijai. Mėnesio ir dienos kombinacija rodo, kad esate čia, kad pakeltumėte kitus ir skleistumėte universalią meilę.

${NUMBER_DESCRIPTIONS[9].character}`,
    destiny: 'Humanizmas, tarnavimas, universali meilė'
  },
  11: {
    title: 'Likimo skaičius 11 – Įkvėpimo kelias (Meistro)',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - MEISTRO SKAIČIUS 11]
    
Jūsų likimas yra būti dvasiniu švyturiu. Tai meistro skaičius, rodantis ypatingą misiją įkvėpti ir šviesti kitus.

${NUMBER_DESCRIPTIONS[11].character}`,
    destiny: 'Dvasinis vadovavimas, intuicija, įkvėpimas'
  },
  22: {
    title: 'Likimo skaičius 22 – Statytojo kelias (Meistro)',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - MEISTRO SKAIČIUS 22]
    
Jūsų likimas yra kurti monumentalius dalykus. Tai meistro skaičius, suteikiantis galią paversti didžiausias vizijas realybe.

${NUMBER_DESCRIPTIONS[22].character}`,
    destiny: 'Didžiulės vizijos realizavimas, globalus poveikis'
  },
  33: {
    title: 'Likimo skaičius 33 – Mokytojo kelias (Meistro)',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - MEISTRO SKAIČIUS 33]
    
Jūsų likimas yra mokyti besąlyginės meilės. Tai aukščiausias meistro skaičius, rodantis misiją gydyti ir kelti žmoniją.

${NUMBER_DESCRIPTIONS[33].character}`,
    destiny: 'Mokymas, gydymas, besąlygiška meilė'
  },
  44: {
    title: 'Likimo skaičius 44 – Manifestuotojo kelias (Meistro)',
    description: `[LIKIMO SKAIČIAUS APRAŠYMAS - MEISTRO SKAIČIUS 44]
    
Jūsų likimas yra materializuoti didžiausias vizijas. Tai galingas meistro skaičius, suteikiantis neįtikėtiną gebėjimą kurti realybę.

${NUMBER_DESCRIPTIONS[44]?.character || NUMBER_DESCRIPTIONS[8].character}`,
    destiny: 'Materialinė manifestacija, sisteminis kūrimas'
  }
};
